import {
  User,
  Department,
  Post,
  Tender,
  Facility,
  FacilityType,
  Event,
  FormSchema,
  Talent,
  Subsite,
  Complaint,
  SecurityClearance,
  PortfolioItem,
  Delegation,
  SiteSettings,
} from '@/types';

// Users
export const users: User[] = [
  {
    id: 'user-1',
    name: 'أحمد محمد',
    email: 'admin@moys.gov.iq',
    phone: '+964 770 123 4567',
    role: 'SuperAdmin',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'user-2',
    name: 'فاطمة علي',
    email: 'media@moys.gov.iq',
    phone: '+964 771 234 5678',
    role: 'MediaDept',
    createdAt: '2023-02-01T00:00:00Z',
  },
  {
    id: 'user-3',
    name: 'علي حسن',
    email: 'dept.admin@moys.gov.iq',
    phone: '+964 772 345 6789',
    role: 'DeptAdmin',
    departmentId: 'dept-1',
    createdAt: '2023-03-01T00:00:00Z',
  },
];

// Departments
export const departments: Department[] = [
  {
    id: 'dept-1',
    slug: 'sports-development',
    nameAr: 'دائرة تطوير الرياضة',
    nameEn: 'Sports Development Department',
    nameKu: 'بەڕێوەبەرایەتی گەشەپێدانی وەرزش',
    description: {
      ar: 'مسؤولة عن تطوير البنية التحتية الرياضية وتدريب المواهب الرياضية',
      en: 'Responsible for developing sports infrastructure and training athletic talents',
      ku: 'بەرپرسیارە لە گەشەپێدانی ژێرخانی وەرزشی و ڕاهێنانی بەهرە وەرزشییەکان',
    },
    contacts: {
      email: 'sports.dev@moys.gov.iq',
      phone: '+964 1 7765432',
      address: {
        ar: 'بغداد، المنصور، شارع الأميرات',
        en: 'Baghdad, Al-Mansour, Al-Amirat Street',
        ku: 'بەغدا، مەنسور، شەقامی ئەمیرات',
      },
    },
    featured: true,
    bannerImage: 'https://images.unsplash.com/photo-1502877338535-766e1452684a?q=80&w=1600&auto=format&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1546519638-68e109498ffc?q=80&w=1600&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502810190503-830027f2cc53?q=80&w=1600&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?q=80&w=1600&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1600&auto=format&fit=crop',
    ],
    videos: [
      'https://www.youtube.com/embed/2Vv-BfVoq4g',
      'https://www.youtube.com/embed/kXYiU_JCYtU',
    ],
    managerName: 'د. علي حسن الربيعي',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-2',
    slug: 'youth-affairs',
    nameAr: 'دائرة شؤون الشباب',
    nameEn: 'Youth Affairs Department',
    nameKu: 'بەڕێوەبەرایەتی کاروباری لاوان',
    description: {
      ar: 'تعزيز دور الشباب في المجتمع وتقديم البرامج التدريبية والتوعوية',
      en: 'Enhancing youth role in society and providing training and awareness programs',
      ku: 'بەهێزکردنی ڕۆڵی لاوان لە کۆمەڵگا و دابینکردنی بەرنامەی ڕاهێنان و هۆشیاری',
    },
    contacts: {
      email: 'youth@moys.gov.iq',
      phone: '+964 1 7765433',
      address: {
        ar: 'بغداد، الكرادة، شارع الثقافة',
        en: 'Baghdad, Al-Karada, Culture Street',
        ku: 'بەغدا، کەرادە، شەقامی کلتور',
      },
    },
    featured: true,
    bannerImage: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1600&auto=format&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1533240332313-0db49b459ad7?q=80&w=1600&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1520975916090-3105956dac38?q=80&w=1600&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1600&auto=format&fit=crop',
    ],
    videos: ['https://www.youtube.com/embed/e-ORhEE9VVg'],
    managerName: 'سارة أحمد الجبوري',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-3',
    slug: 'investment-finance',
    nameAr: 'دائرة الاستثمار والتمويل الذاتي',
    nameEn: 'Investment & Self-Finance Department',
    nameKu: 'بەڕێوەبەرایەتی وەبەرهێنان و خۆدارایی',
    description: {
      ar: 'إدارة مناقصات الوزارة والمشاريع الاستثمارية',
      en: 'Managing ministry tenders and investment projects',
      ku: 'بەڕێوەبردنی مناقەسەکانی وەزارەت و پرۆژە وەبەرهێنانەکان',
    },
    contacts: {
      email: 'investment@moys.gov.iq',
      phone: '+964 1 7765434',
      address: {
        ar: 'بغداد، الجادرية',
        en: 'Baghdad, Al-Jadriya',
        ku: 'بەغدا، جادریە',
      },
    },
    featured: true,
    bannerImage: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1600&auto=format&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=1600&auto=format&fit=crop',
    ],
    managerName: 'كريم عباس الموسوي',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-4',
    slug: 'media-communication',
    nameAr: 'دائرة الإعلام والاتصال',
    nameEn: 'Media & Communication Department',
    nameKu: 'بەڕێوەبەرایەتی میدیا و پەیوەندی',
    description: {
      ar: 'إدارة المحتوى الإعلامي والعلاقات العامة',
      en: 'Managing media content and public relations',
      ku: 'بەڕێوەبردنی ناوەڕۆکی میدیا و پەیوەندییە گشتییەکان',
    },
    contacts: {
      email: 'media@moys.gov.iq',
      phone: '+964 1 7765435',
      address: {
        ar: 'بغداد، الكرخ',
        en: 'Baghdad, Al-Karkh',
        ku: 'بەغدا، کەرخ',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1526378722484-bd91ca387e72?q=80&w=1600&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1600&auto=format&fit=crop',
    ],
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-5',
    slug: 'scientific-care',
    nameAr: 'دائرة الرعاية العلمية',
    nameEn: 'Scientific Care Department',
    nameKu: 'بەڕێوەبەرایەتی چاودێری زانستی',
    description: {
      ar: 'رعاية المواهب العلمية والبحث في المجالات الرياضية والبدنية',
      en: 'Caring for scientific talents and research in sports and physical fields',
      ku: 'چاودێریکردنی بەهرە زانستییەکان و توێژینەوە لە بواری وەرزش و جەستەیی',
    },
    contacts: {
      email: 'scientific@moys.gov.iq',
      phone: '+964 1 7765436',
      address: {
        ar: 'بغداد، الأعظمية، شارع الجامعة',
        en: 'Baghdad, Al-Adhamiya, University Street',
        ku: 'بەغدا، ئەعزەمیە، شەقامی زانکۆ',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=1600&auto=format&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1600&auto=format&fit=crop',
    ],
    managerName: 'د. محمد علي الكاظمي',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-6',
    slug: 'talent-care',
    nameAr: 'المركز الوطني لرعاية الموهبة الرياضية',
    nameEn: 'National Center for Sports Talent Care',
    nameKu: 'ناوەندی نیشتمانی چاودێری بەهرەی وەرزشی',
    description: {
      ar: 'اكتشاف ورعاية المواهب الرياضية في جميع الألعاب',
      en: 'Discovering and caring for sports talents in all games',
      ku: 'دۆزینەوە و چاودێریکردنی بەهرە وەرزشییەکان لە هەموو یارییەکاندا',
    },
    contacts: {
      email: 'talent@moys.gov.iq',
      phone: '+964 1 7765437',
      address: {
        ar: 'بغداد، الكاظمية، شارع الإمام الكاظم',
        en: 'Baghdad, Al-Kadhimiya, Imam Al-Kadhim Street',
        ku: 'بەغدا، کازیمیە، شەقامی ئیمام کازیم',
      },
    },
    featured: true,
    bannerImage: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?q=80&w=1600&auto=format&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1600&auto=format&fit=crop',
    ],
    managerName: 'أ.د. فاطمة محمود',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-7',
    slug: 'legal-affairs',
    nameAr: 'دائرة الشؤون القانونية',
    nameEn: 'Legal Affairs Department',
    nameKu: 'بەڕێوەبەرایەتی کاروباری یاسایی',
    description: {
      ar: 'إدارة الشؤون القانونية والعقود والاتفاقيات',
      en: 'Managing legal affairs, contracts and agreements',
      ku: 'بەڕێوەبردنی کاروباری یاسایی، گرێبەست و ڕێکەوتنەکان',
    },
    contacts: {
      email: 'legal@moys.gov.iq',
      phone: '+964 1 7765438',
      address: {
        ar: 'بغداد، الرصافة، شارع الرشيد',
        en: 'Baghdad, Al-Rusafa, Al-Rashid Street',
        ku: 'بەغدا، ڕوسافە، شەقامی ڕەشید',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1600&auto=format&fit=crop',
    managerName: 'م. علياء سعد الدين',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-8',
    slug: 'planning-statistics',
    nameAr: 'دائرة التخطيط والإحصاء',
    nameEn: 'Planning & Statistics Department',
    nameKu: 'بەڕێوەبەرایەتی پلاندانان و ئامار',
    description: {
      ar: 'وضع الخطط الاستراتيجية وجمع البيانات الإحصائية',
      en: 'Developing strategic plans and collecting statistical data',
      ku: 'دانانی پلانە ئیستراتیژییەکان و کۆکردنەوەی داتای ئاماری',
    },
    contacts: {
      email: 'planning@moys.gov.iq',
      phone: '+964 1 7765439',
      address: {
        ar: 'بغداد، الوزيرية',
        en: 'Baghdad, Al-Waziriya',
        ku: 'بەغدا، وەزیریە',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1600&auto=format&fit=crop',
    managerName: 'د. خالد إبراهيم',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-9',
    slug: 'international-relations',
    nameAr: 'دائرة العلاقات الدولية',
    nameEn: 'International Relations Department',
    nameKu: 'بەڕێوەبەرایەتی پەیوەندییە نێودەوڵەتییەکان',
    description: {
      ar: 'إدارة العلاقات الدولية والاتفاقيات الرياضية',
      en: 'Managing international relations and sports agreements',
      ku: 'بەڕێوەبردنی پەیوەندییە نێودەوڵەتییەکان و ڕێکەوتنە وەرزشییەکان',
    },
    contacts: {
      email: 'international@moys.gov.iq',
      phone: '+964 1 7765440',
      address: {
        ar: 'بغداد، المنطقة الخضراء',
        en: 'Baghdad, Green Zone',
        ku: 'بەغدا، ناوچەی سەوز',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=1600&auto=format&fit=crop',
    managerName: 'د. سامراء أحمد',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-10',
    slug: 'facilities-management',
    nameAr: 'دائرة إدارة المنشآت',
    nameEn: 'Facilities Management Department',
    nameKu: 'بەڕێوەبەرایەتی بەڕێوەبردنی دامەزراوەکان',
    description: {
      ar: 'إدارة وصيانة المنشآت الرياضية في جميع المحافظات',
      en: 'Managing and maintaining sports facilities across all governorates',
      ku: 'بەڕێوەبردنی و چاککردنی دامەزراوە وەرزشییەکان لە هەموو پارێزگاکاندا',
    },
    contacts: {
      email: 'facilities@moys.gov.iq',
      phone: '+964 1 7765441',
      address: {
        ar: 'بغداد، الشعب، شارع المطار',
        en: 'Baghdad, Al-Shaab, Airport Street',
        ku: 'بەغدا، شەعب، شەقامی فرۆکەخانە',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=1600&auto=format&fit=crop',
    managerName: 'م. حيدر كريم',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-11',
    slug: 'women-sports',
    nameAr: 'دائرة الرياضة النسوية',
    nameEn: 'Women\'s Sports Department',
    nameKu: 'بەڕێوەبەرایەتی وەرزشی ژنان',
    description: {
      ar: 'تطوير ودعم الرياضة النسوية في العراق',
      en: 'Developing and supporting women\'s sports in Iraq',
      ku: 'گەشەپێدان و پشتگیری وەرزشی ژنان لە عێراق',
    },
    contacts: {
      email: 'womensports@moys.gov.iq',
      phone: '+964 1 7765442',
      address: {
        ar: 'بغداد، الكرادة الداخلية',
        en: 'Baghdad, Inner Karada',
        ku: 'بەغدا، کەرادەی ناوەوە',
      },
    },
    featured: true,
    bannerImage: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1600&auto=format&fit=crop',
    managerName: 'د. نورا صالح',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-12',
    slug: 'anti-doping',
    nameAr: 'دائرة مكافحة المنشطات',
    nameEn: 'Anti-Doping Department',
    nameKu: 'بەڕێوەبەرایەتی بەرەنگاربوونەوەی دەرمان',
    description: {
      ar: 'مكافحة المنشطات وضمان النزاهة الرياضية',
      en: 'Fighting doping and ensuring sports integrity',
      ku: 'بەرەنگاربوونەوەی دەرمان و دڵنیابوون لە پاکی وەرزشی',
    },
    contacts: {
      email: 'antidoping@moys.gov.iq',
      phone: '+964 1 7765443',
      address: {
        ar: 'بغداد، المنصور، شارع الأميرات',
        en: 'Baghdad, Al-Mansour, Al-Amirat Street',
        ku: 'بەغدا، مەنسور، شەقامی ئەمیرات',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1600&auto=format&fit=crop',
    managerName: 'د. رائد محمود',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-13',
    slug: 'sports-medicine',
    nameAr: 'دائرة الطب الرياضي',
    nameEn: 'Sports Medicine Department',
    nameKu: 'بەڕێوەبەرایەتی پزیشکی وەرزشی',
    description: {
      ar: 'الرعاية الطبية للرياضيين والفحوصات الدورية',
      en: 'Medical care for athletes and periodic examinations',
      ku: 'چاودێری پزیشکی بۆ وەرزشوانان و پشکنینی خولەکی',
    },
    contacts: {
      email: 'sportsmedicine@moys.gov.iq',
      phone: '+964 1 7765444',
      address: {
        ar: 'بغداد، الكرادة، مستشفى الكرادة',
        en: 'Baghdad, Al-Karada, Al-Karada Hospital',
        ku: 'بەغدا، کەرادە، نەخۆشخانەی کەرادە',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1600&auto=format&fit=crop',
    managerName: 'د. زينب علي',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-14',
    slug: 'coaching-education',
    nameAr: 'دائرة التدريب والتعليم',
    nameEn: 'Coaching & Education Department',
    nameKu: 'بەڕێوەبەرایەتی ڕاهێنان و پەروەردە',
    description: {
      ar: 'تدريب المدربين وتطوير المناهج الرياضية',
      en: 'Training coaches and developing sports curricula',
      ku: 'ڕاهێنانی ڕاهێنەران و گەشەپێدانی منھاجە وەرزشییەکان',
    },
    contacts: {
      email: 'coaching@moys.gov.iq',
      phone: '+964 1 7765445',
      address: {
        ar: 'بغداد، الجادرية، مجمع التدريب',
        en: 'Baghdad, Al-Jadriya, Training Complex',
        ku: 'بەغدا، جادریە، کۆمپلێکسی ڕاهێنان',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1600&auto=format&fit=crop',
    managerName: 'أ.د. حسن كاظم',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-15',
    slug: 'youth-camps',
    nameAr: 'دائرة المخيمات الشبابية',
    nameEn: 'Youth Camps Department',
    nameKu: 'بەڕێوەبەرایەتی کەمپی لاوان',
    description: {
      ar: 'تنظيم وإدارة المخيمات الشبابية والرياضية',
      en: 'Organizing and managing youth and sports camps',
      ku: 'ڕێکخستن و بەڕێوەبردنی کەمپە لاوان و وەرزشییەکان',
    },
    contacts: {
      email: 'camps@moys.gov.iq',
      phone: '+964 1 7765446',
      address: {
        ar: 'بغداد، الكاظمية',
        en: 'Baghdad, Al-Kadhimiya',
        ku: 'بەغدا، کازیمیە',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?q=80&w=1600&auto=format&fit=crop',
    managerName: 'م. علي محسن',
    createdAt: '2023-01-01T00:00:00Z',
  },
  {
    id: 'dept-16',
    slug: 'sports-federations',
    nameAr: 'دائرة الاتحادات الرياضية',
    nameEn: 'Sports Federations Department',
    nameKu: 'بەڕێوەبەرایەتی یەکێتی وەرزشییەکان',
    description: {
      ar: 'الإشراف على الاتحادات الرياضية وتنسيق أنشطتها',
      en: 'Supervising sports federations and coordinating their activities',
      ku: 'چاودێریکردنی یەکێتی وەرزشییەکان و هەماهەنگیکردنی چالاکییەکانیان',
    },
    contacts: {
      email: 'federations@moys.gov.iq',
      phone: '+964 1 7765447',
      address: {
        ar: 'بغداد، المنصور، مجمع الاتحادات',
        en: 'Baghdad, Al-Mansour, Federations Complex',
        ku: 'بەغدا، مەنسور، کۆمپلێکسی یەکێتییەکان',
      },
    },
    featured: false,
    bannerImage: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?q=80&w=1600&auto=format&fit=crop',
    managerName: 'د. أحمد عبدالله',
    createdAt: '2023-01-01T00:00:00Z',
  },
];

// Posts (News Articles)
export const posts: Post[] = [
  {
    id: 'post-1',
    titleAr: 'افتتاح ملعب كرة القدم الجديد في البصرة',
    titleEn: 'Opening of New Football Stadium in Basra',
    titleKu: 'کردنەوەی یاریگای نوێی تۆپی پێ لە بەسرە',
    slug: 'new-stadium-basra',
    bodyRich: {
      ar: '<p>افتتح معالي الوزير ملعب كرة القدم الجديد في محافظة البصرة بسعة 40,000 متفرج. يعد المشروع جزءاً من خطة تطوير البنية التحتية الرياضية في العراق.</p><p>يتضمن الملعب أحدث المواصفات العالمية ومرافق تدريبية متطورة.</p>',
      en: '<p>The Minister inaugurated the new football stadium in Basra Governorate with a capacity of 40,000 spectators. The project is part of the sports infrastructure development plan in Iraq.</p><p>The stadium includes the latest international specifications and advanced training facilities.</p>',
      ku: '<p>وەزیر یاریگای نوێی تۆپی پێی لە بەسرە کردەوە کە دەتوانێت ٤٠٬٠٠٠ تەماشاکار لەخۆبگرێت. ئەم پرۆژەیە بەشێکە لە پلانی گەشەپێدانی ژێرخانی وەرزشی لە عێراق.</p><p>یاریگاکە تایبەتمەندییە نوێترینە نێودەوڵەتییەکان و شوێنە پێشکەوتووەکانی ڕاهێنانی تێدایە.</p>',
    },
    tags: ['ملعب', 'البصرة', 'افتتاح', 'رياضة'],
    departmentId: 'dept-1',
    status: 'published',
    authorId: 'user-1',
    featuredImage: 'https://picsum.photos/seed/stadium1/800/600',
    images: [
      'https://picsum.photos/seed/stadium1/1200/800',
      'https://picsum.photos/seed/stadium1b/1200/800',
      'https://picsum.photos/seed/stadium1c/1200/800',
    ],
    publishedAt: '2024-10-15T10:00:00Z',
    createdAt: '2024-10-10T08:00:00Z',
    updatedAt: '2024-10-15T10:00:00Z',
  },
  {
    id: 'post-2',
    titleAr: 'إطلاق برنامج تدريبي للمدربين الرياضيين',
    titleEn: 'Launch of Training Program for Sports Coaches',
    titleKu: 'دەستپێکردنی بەرنامەی ڕاهێنان بۆ ڕاهێنەرە وەرزشییەکان',
    slug: 'coach-training-program',
    bodyRich: {
      ar: '<p>أعلنت وزارة الشباب والرياضة عن إطلاق برنامج تدريبي شامل للمدربين الرياضيين بالتعاون مع خبراء دوليين.</p>',
      en: '<p>The Ministry of Youth and Sports announced the launch of a comprehensive training program for sports coaches in cooperation with international experts.</p>',
      ku: '<p>وەزارەتی لاوان و وەرزش بەرنامەیەکی ڕاهێنانی گشتگیری ڕاگەیاند بۆ ڕاهێنەرە وەرزشییەکان بە هاوکاری لەگەڵ پسپۆڕانی نێودەوڵەتی.</p>',
    },
    tags: ['تدريب', 'مدربين', 'تطوير'],
    departmentId: 'dept-1',
    status: 'published',
    authorId: 'user-3',
    featuredImage: 'https://picsum.photos/seed/training1/800/600',
    images: [
      'https://picsum.photos/seed/training1/1200/800',
      'https://picsum.photos/seed/training1b/1200/800',
    ],
    publishedAt: '2024-10-20T09:00:00Z',
    createdAt: '2024-10-18T07:00:00Z',
    updatedAt: '2024-10-20T09:00:00Z',
  },
  {
    id: 'post-3',
    titleAr: 'مؤتمر الشباب العراقي 2024',
    titleEn: 'Iraqi Youth Conference 2024',
    titleKu: 'کۆنفرانسی لاوانی عێراقی ٢٠٢٤',
    slug: 'youth-conference-2024',
    bodyRich: {
      ar: '<p>تستضيف بغداد المؤتمر السنوي للشباب العراقي بمشاركة أكثر من 500 شاب وشابة من جميع المحافظات.</p>',
      en: '<p>Baghdad hosts the annual Iraqi Youth Conference with participation of more than 500 young men and women from all governorates.</p>',
      ku: '<p>بەغدا میوانداری کۆنفرانسی ساڵانەی لاوانی عێراقی دەکات بە بەشداری زیاتر لە ٥٠٠ گەنج لە هەموو پارێزگاکانەوە.</p>',
    },
    tags: ['مؤتمر', 'شباب', 'بغداد'],
    departmentId: 'dept-2',
    status: 'pending',
    authorId: 'user-3',
    featuredImage: 'https://picsum.photos/seed/conference1/800/600',
    images: [
      'https://picsum.photos/seed/conference1/1200/800',
      'https://picsum.photos/seed/conference1b/1200/800',
    ],
    createdAt: '2024-10-25T08:00:00Z',
    updatedAt: '2024-10-25T08:00:00Z',
  },
  // Added from MOYS GCS news (category feed). Source: https://gcs.moys.gov.iq/?cat=6
  {
    id: 'post-4',
    titleAr: 'الشركة العامة للاستثمارات الرياضية تحتفي بالأستاذ علي حسين علوان',
    titleEn: 'General Company for Sports Investments honors Ali Hussein Alwan',
    titleKu: 'کۆمپانیای گشتی وەبەرهێنان وەرزشی پڕۆفیسۆر علی حسین عەلوان دەخوازێت',
    slug: 'gcs-honor-ali-hussein-alwan',
    bodyRich: {
      ar: '<p>برعاية مدير عام الشركة المهندس حيدر جاسم عرنوص ومعاون مدير عام الشركة المهندس ماجد غازي ورؤساء الاقسام كافة مع موظفي الشركة، نظمت الشركة العامة للاستثمارات الرياضية، حفل تكريم للاستاذ الفاضل علي حسين علوان، معاون رئيس قسم الشؤون المالية، لاحالته على التقاعد، تقديرا لجهوده المبذولة طيلة ايام خدمته وتفانيه في العمل.</p><p>واوضح السيد المدير العام خلال الحفل، ان التقاعد اجمل ما يصل اليه الموظف في حياته المهنية، وقد اثبت السيد علي حسين علوان للجميع، ان التميز يأتي بالسعي تاركا ارثا من الانجازات والنجاحات.. رحلتكم معنا كانت دائما مثالا للتفاني والاخلاص.</p>',
      en: '<p>Under the patronage of the director general and the deputy, the General Company for Sports Investments held a ceremony to honor Mr. Ali Hussein Alwan, the deputy head of the Financial Affairs Department, in appreciation of his efforts.</p>',
      ku: '<p>بە چاودێری بەڕێوەبەری گشتی، کۆمپانیاکە ئاڕاستەیەکی پێشوازی بۆ ئالی حوسێن عەلوان کرد.</p>',
    },
    tags: ['تكريم', 'الشركة العامة للاستثمارات الرياضية'],
    departmentId: 'dept-3',
    status: 'published',
    authorId: 'user-2',
    featuredImage: 'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/572905734_838451011903381_4298286532693098596_n.jpg',
    images: [
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/572905734_838451011903381_4298286532693098596_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/11/IMG_9097-1-2048x1150.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/11/IMG_9104-2048x1150.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/11/IMG_9112-2048x1150.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/11/IMG_9103-2048x1150.jpg',
    ],
    publishedAt: '2025-11-03T06:01:00Z',
    createdAt: '2025-11-03T06:01:00Z',
    updatedAt: '2025-11-03T06:01:00Z',
  },
  {
    id: 'post-6',
    titleAr: 'المبرقع يكرم المبدعين والمتفوقين في مدينة بسماية',
    titleEn: 'Minister Al-Mabriq honors creatives and top achievers in Basmaya',
    titleKu: 'وزیر مەبرقع داهێنەر و سەرکەوتووەکان لە بسامایە دەخوازێت',
    slug: 'minister-honors-basmaya-creatives',
    bodyRich: {
      ar: '<p>برعاية وحضور وزير الشباب والرياضة الدكتور أحمد المبرقع، أقامت وزارة الشباب والرياضة حفل تكريم المتفوقين والمبدعين والمؤثرين في مدينة بسماية، وذلك على ملعب بسماية الكبير، بحضور المدير العام للشركة العامة للاستثمارات الرياضية المهندس حيدر جاسم عرنوص.</p><p>وأشاد السيد الوزير بجهود ملاكات مركز الموهبة في مدينة بسماية، لما يقدمونه من جهود كبيرة في رعاية المواهب وتمنيتها، معبراً عن سعادته الكبيرة وهو يرى ثمار العمل الذي نقوم به خلال السنوات الثلاث الماضية.</p><p>وأكد السيد الوزير أن مدينة بسماية زاخرة بالمبدعين والمتفوقين في مختلف المجالات الشبابية والرياضية بما تضمها من فعاليات عدة، مشدداً على أن وزارة الشباب والرياضة تعمل وفقاً لاستراتيجية واضحة وهي رعاية ودعم هذه الفئات في مختلف محافظات ومناطق العراق.</p>',
      en: '<p>Under the patronage and presence of the Minister of Youth and Sports, Dr. Ahmed Al-Mabriq, the Ministry organized an honoring ceremony for top achievers, creatives, and influencers in Basmaya City at the Grand Basmaya Stadium, attended by the Director General of the General Company for Sports Investments, Eng. Haider Jassim Arnoos.</p><p>The Minister praised the efforts of the Talent Center staff in Basmaya for their great work in nurturing and developing talents, expressing his happiness at seeing the fruits of work over the past three years.</p><p>He affirmed that Basmaya is rich with creatives and top achievers in various youth and sports fields, emphasizing that the Ministry operates under a clear strategy to support these groups across Iraq.</p>',
      ku: '<p>بە چاودێری و هاتنی وزیری لاوان و وەرزش د. ئەحمەد مەبرقع، وەزارەتەکە ئاھەنگێکی خۆشحاڵکردن بۆ سەرکەوتوو و داهێنەران و کەسایەتییە کاریگەرەکان لە شارەکەی بسامایە ڕێکخست، لە یاریگای گەورەی بسامایە، بە هاتی نیوەی بەڕێوەبەری گشتیی کۆمپانیای گشتیی وەبەرهێنانە وەرزشییەکان، ئەندازیار حیدەر جاسم عرنوص.</p><p>وزیرەکە سوپاسی هاوکارانی ناوەندی تواناسازی لە بسامایە کرد بۆ ئەو هەوڵانەی زۆرانیان بەڵگە دەدەن لە پاراستن و گەشەپێدانی تواناکان، وە ئەو خۆشحاڵییەی خۆی باس کرد کە دەتوانێت بەرهەمەکانی کارەکان لە سه‌ره‌تا ٣ ساڵی ڕابردوودا ببینێت.</p><p>دڵنیایی دا کە بسامایە پڕە لە داهێنەر و سەرکەوتووەکان لە بواری لاوان و وەرزشدا و وتی وەزارەت بە یاسای ستراتیجیایەکی ڕوون کار دەکات بۆ پشتگیری ئەم کۆمەڵگەیە لە هەموو پارێزگاکانی عێراقدا.</p>',
    },
    tags: ['بسماية', 'تكريم', 'وزير الشباب والرياضة'],
    departmentId: 'dept-3',
    status: 'published',
    authorId: 'user-2',
    featuredImage: 'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/571152332_1200886548740509_3007708716022833018_n.jpg',
    images: [
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/571152332_1200886548740509_3007708716022833018_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/568708921_1200887405407090_2321197456545523787_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/569214963_1200887415407089_7295421454187194448_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/569333009_1200887708740393_6668338463254332987_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/570333436_1200886968740467_6715313955497416298_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/570438115_1200886875407143_919469608390364878_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/570642806_1200886885407142_3444104645677772644_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/571116464_1200887542073743_8366009444675936430_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/571140278_1200887492073748_5029009663278367345_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/571337957_1200887282073769_7491985227287064585_n-1.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/571409602_1200887618740402_654206305803105501_n.jpg',
    ],
    publishedAt: '2025-10-20T06:00:00Z',
    createdAt: '2025-10-20T06:00:00Z',
    updatedAt: '2025-10-20T06:00:00Z',
  },
  {
    id: 'post-7',
    titleAr: 'المبرقع: الوزارة الاكفأ في إدارة وصيانة الملاعب وقدمت نموذجاً ناجحاً في الاستثمار الرياضي',
    titleEn: 'Minister: The ministry is most capable in stadium management and a model for successful sports investment',
    titleKu: 'وزیر: وەزارەت بە تواناترینە لە بەڕێوەبردن و چاککردنی یاریگا و نموونەیەکی سەرکەوتوو لە وەبەرهێنان',
    slug: 'ministry-capable-stadiums-successful-investment',
    bodyRich: {
      ar: '<p>أكد وزير الشباب والرياضة الدكتور أحمد المبرقع: أن الشركة العامة للاستثمارات الرياضية قدمت عملاً كبيراً وإنجازات واضحة، مشيراً إلى أن هذه الجهود تمثل جزءاً من منظومة واسعة تعمل الوزارة على ترسيخها لتعزيز الصورة لأنها وزارة تخدم قطاعي الشباب والرياضة معاً.</p><p>جاء ذلك، خلال حضور السيد الوزير، اليوم الأربعاء، احتفالية عرض إنجازات الشركة للأعوام 2023 و2024 و2025 وتكريم موظفيها، التي أقيمت على قاعة دائرة العلاقات والتعاون الدولي، بحضور وكيل الوزارة لشؤون الرياضة الدكتور حسن الحسناوي والملاك المتقدم، والمحتفى بهم وضيوف الوزارة.</p><p>وبين الدكتور المبرقع: أن هناك خلطاً في الرأي العام بين الوزارة واتحاد كرة القدم، قائلاً: كل فشل يحدث يُرمى على الوزارة، في حين أن مسؤوليتنا تتركز على توفير السبل الكفيلة بتحقيق الإنجاز، أما رعاية المنتخب الوطني فهي من واجباتنا التي أوليناها اهتماماً كبيراً خلال السنوات الثلاث الماضية، وننتظر من أسود الرافدين تحقيق ما يفرح العراقيين الذين يتوحدون خلف المنتخب رغم تعقد فرص التأهل.</p><p>وأضاف الوزير: أن الملاعب العراقية ظهرت بحلة جميلة حينما كانت بعهدة الشركة العامة للاستثمارات الرياضية والدوائر المعنية، إلا أن سحب إدارتها تم وفق “فكرة خاطئة” تحفظت عليها الوزارة، ما أدى إلى تدهور أو خروج بعض الملاعب عن الخدمة.</p><p>وأشار المبرقع إلى أن الوزارة اليوم أمام تحدٍ إعلامي لتوضيح الحقائق وتبرئة ساحتها، مؤكداً أن الوزارة هي الجهة الأكفأ والأحرص على سلامة وإدامة الملاعب بوصفها صاحبة الاختصاص في هذا المجال.</p><p>وفي جانب آخر، تطرق الدكتور المبرقع إلى رؤية الوزارة في مجال الاستثمار الرياضي، مبرزاً تجربة تشغيل وتأهيل مجمع بسماية الرياضي الترفيهي بوصفها نموذجاً ناجحاً للاستثمار الأمثل، إذ حقق المشروع مردوداً مالياً يعادل أكثر من عشرة عقود استثمارية تقليدية، مبيناً أن هذه التجربة تمثل واحدة من مخرجات الاستثمار الناجح للشركة، بخلاف أكثر من (96) عقداً استثمارياً سابقاً لم تحقق المردود المالي أو الطموح المطلوب.</p><p>من جانبه، استعرض المدير العام للشركة العامة للاستثمارات الرياضية ورئيس مجلس إدارتها السيد حيدر جاسم عرنوص أهم إنجازات الشركة وخطة عملها المستقبلية في استثمار الطاقات البشرية والمادية، مشيراً إلى أن ما تحقق لم يكن ليتحقق لولا دعم السيد الوزير ودوائر الوزارة.</p><p>كما قدم معاون المدير العام السيد ماجد غازي عرضاً مرئياً تضمن جداول وإحصاءات لمشاريع ونشاطات الشركة خلال الأعوام الأخيرة.</p><p>وفي ختام الاحتفالية، تسلّم السيد الوزير درع التميز، فيما كرّم الدكتور المبرقع وكيل الوزارة لشؤون الرياضة والمدير العام وأعضاء مجلس إدارة الشركة بدروع تقديرية، إلى جانب تكريم ملاك الشركة بشهادات عرفان وتقدير لجهودهم المتميزة.</p>',
      en: '<p>The Minister of Youth and Sports, Dr. Ahmed Al-Mabriq, affirmed that the General Company for Sports Investments delivered significant achievements as part of a broader vision led by the Ministry. He clarified roles between the Ministry and the Football Association and highlighted Basmaya Sports & Entertainment Complex as a successful investment model.</p>',
      ku: '<p>وزیری لاوان و وەرزش د. ئەحمەد مەبرقع دەڵێت کۆمپانیای گشتیی وەبەرهێنانە وەرزشی کار و دەستکەوتی دیار لەگەڵ بینینێکی فراوان پێشکەش کردووە و نموونەی بسامایە وەک وەبەرهێنانێکی سەرکەوتوو پیشان دەدات.</p>',
    },
    tags: ['وزارة الشباب والرياضة', 'الاستثمارات الرياضية', 'الملاعب', 'تكريم'],
    departmentId: 'dept-3',
    status: 'published',
    authorId: 'user-2',
    featuredImage: 'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/558986068_1198391288990035_4719708487455395034_n.jpg',
    images: [
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/558986068_1198391288990035_4719708487455395034_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/559848845_1198392815656549_3302563764908002848_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/568204964_1198392762323221_5872689094893705120_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/568354145_1198392625656568_1451013308764661832_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/568421308_1198391885656642_438183711129175603_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/568969052_1198392915656539_3950660861628449663_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/569041630_1198392618989902_8395208775147944763_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/569096822_1198391388990025_7319329514410193332_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/569368719_1198392478989916_4808305292430621044_n.jpg',
      'https://gcs.moys.gov.iq/wp-content/uploads/2025/10/569373568_1198392745656556_7243413568832808843_n.jpg',
    ],
    publishedAt: '2025-10-22T06:00:00Z',
    createdAt: '2025-10-22T06:00:00Z',
    updatedAt: '2025-10-22T06:00:00Z',
  },
  
];

// Tenders
export const tenders: Tender[] = [
  {
    id: 'tender-1',
    titleAr: 'إنشاء مجمع رياضي متكامل في أربيل',
    titleEn: 'Construction of Integrated Sports Complex in Erbil',
    titleKu: 'بنیاتنانی کۆمەڵەیەکی وەرزشی یەکگرتوو لە هەولێر',
    refNo: 'MOYS-2024-001',
    status: 'announced',
    publishDate: '2024-10-01T00:00:00Z',
    closeDate: '2024-12-01T00:00:00Z',
    attachments: [
      {
        id: 'att-1',
        name: 'tender_specifications_ar.pdf',
        url: '/docs/tender_specifications_ar.pdf',
        size: 2048576,
        type: 'application/pdf',
        uploadedAt: '2024-10-01T00:00:00Z',
      },
    ],
    departmentId: 'dept-3',
    descriptionRich: {
      ar: '<p>مناقصة لإنشاء مجمع رياضي متكامل يتضمن ملاعب وصالات رياضية ومسابح.</p>',
      en: '<p>Tender for construction of integrated sports complex including stadiums, sports halls, and pools.</p>',
      ku: '<p>مناقەسە بۆ بنیاتنانی کۆمەڵەیەکی وەرزشی یەکگرتوو لەوانە یاریگا و هۆڵی وەرزشی و مەلەوانگە.</p>',
    },
    budget: 15000000,
    currency: 'IQD',
    registrations: 12,
    createdAt: '2024-10-01T00:00:00Z',
    updatedAt: '2024-10-15T00:00:00Z',
  },
  {
    id: 'tender-2',
    titleAr: 'توريد معدات رياضية',
    titleEn: 'Supply of Sports Equipment',
    titleKu: 'دابینکردنی کەلوپەلی وەرزشی',
    refNo: 'MOYS-2024-002',
    status: 'submission',
    publishDate: '2024-09-15T00:00:00Z',
    closeDate: '2024-11-15T00:00:00Z',
    attachments: [],
    departmentId: 'dept-3',
    descriptionRich: {
      ar: '<p>توريد معدات رياضية متنوعة للمراكز الشبابية في جميع المحافظات.</p>',
      en: '<p>Supply of various sports equipment for youth centers in all governorates.</p>',
      ku: '<p>دابینکردنی کەلوپەلی جۆراوجۆری وەرزشی بۆ سەنتەرە گەنجانەکانی هەموو پارێزگاکان.</p>',
    },
    budget: 5000000,
    currency: 'IQD',
    registrations: 8,
    createdAt: '2024-09-15T00:00:00Z',
    updatedAt: '2024-10-10T00:00:00Z',
  },
];

// Enrich demo: add older news posts and tenders for pagination testing
// Generate 12 older posts (published before existing ones)
for (let i = 0; i < 12; i++) {
  const date = new Date('2024-06-01T00:00:00Z');
  date.setDate(date.getDate() - i * 7);
  posts.push({
    id: `post-old-${i + 1}`,
    titleAr: `خبر تجريبي قديم رقم ${i + 1}`,
    titleEn: `Legacy Demo News ${i + 1}`,
    titleKu: `هەواڵی کۆنی دێمو ${i + 1}`,
    slug: `legacy-news-${i + 1}`,
    bodyRich: { ar: '<p>محتوى تجريبي للأخبار القديمة.</p>', en: '<p>Demo legacy news content.</p>', ku: '<p>ناوەڕۆکی دێمۆ بۆ هەواڵە کۆنەکان.</p>' },
    tags: ['خبر', 'تجريبي'],
    departmentId: 'dept-4',
    status: 'published',
    authorId: 'user-2',
    featuredImage: `https://picsum.photos/seed/legacy${i}/800/600`,
    images: [`https://picsum.photos/seed/legacy${i}/1200/800`],
    publishedAt: date.toISOString(),
    createdAt: date.toISOString(),
    updatedAt: date.toISOString(),
  } as Post);
}

// Generate 8 older tenders (publish dates before current ones)
for (let i = 0; i < 8; i++) {
  const p = new Date('2024-08-01T00:00:00Z');
  p.setDate(p.getDate() - i * 10);
  const c = new Date(p);
  c.setMonth(c.getMonth() + 1);
  tenders.push({
    id: `tender-old-${i + 1}`,
    titleAr: `مناقصة تجريبية قديمة ${i + 1}`,
    titleEn: `Legacy Demo Tender ${i + 1}`,
    titleKu: `مناقصەی دێمۆ کۆن ${i + 1}`,
    refNo: `MOYS-2024-LEG-${i + 1}`,
    status: i % 3 === 0 ? 'awarded' : i % 2 === 0 ? 'submission' : 'announced',
    publishDate: p.toISOString(),
    closeDate: c.toISOString(),
    attachments: [],
    departmentId: 'dept-3',
    descriptionRich: { ar: '<p>تفاصيل مناقصة تجريبية.</p>', en: '<p>Demo tender details.</p>', ku: '<p>وردەکارییەکانی مناقصەی دێمۆ.</p>' },
    budget: 1000000 + i * 250000,
    currency: 'IQD',
    registrations: Math.floor(Math.random() * 20),
    createdAt: p.toISOString(),
    updatedAt: p.toISOString(),
  } as Tender);
}

// Facilities
const iraqiCities = [
  { province: 'Baghdad', city: 'Baghdad', lat: 33.3152, lng: 44.3661 },
  { province: 'Basra', city: 'Basra', lat: 30.5085, lng: 47.7836 },
  { province: 'Mosul', city: 'Mosul', lat: 36.3350, lng: 43.1189 },
  { province: 'Erbil', city: 'Erbil', lat: 36.1911, lng: 44.0092 },
  { province: 'Najaf', city: 'Najaf', lat: 31.9996, lng: 44.3236 },
  { province: 'Karbala', city: 'Karbala', lat: 32.6160, lng: 44.0248 },
  { province: 'Sulaymaniyah', city: 'Sulaymaniyah', lat: 35.5564, lng: 45.4329 },
  { province: 'Duhok', city: 'Duhok', lat: 36.8618, lng: 42.9958 },
];

const facilityTemplates = [
  {
    type: 'stadium' as FacilityType,
    photoSeed: 'stadium',
    capacity: { min: 28000, max: 55000 },
    amenities: ['مقاعد VIP', 'مواقف سيارات', 'مرافق طبية', 'لوحات عرض رقمية'],
    buildName: (city: string) => ({
      ar: `ملعب ${city} الدولي`,
      en: `${city} International Stadium`,
      ku: `یاریگای نێودەوڵەتی ${city}`,
    }),
    buildDescription: (city: string) => ({
      ar: `ملعب حديث بتجهيزات عالمية يستضيف أبرز البطولات في ${city}.`,
      en: `A modern stadium with international-grade infrastructure hosting the biggest events in ${city}.`,
      ku: `یاریگایەکی نوێ بە ئامادەکاری نێودەوڵەتی کە گەلەك ڕووداوی گرنگ لە ${city} دەگرێت.`,
    }),
  },
  {
    type: 'club' as FacilityType,
    photoSeed: 'club',
    amenities: ['صالة متعددة الأغراض', 'مسبح أولمبي', 'مدرسة كرة قدم', 'مقهى رياضي'],
    buildName: (city: string) => ({
      ar: `نادي ${city} الرياضي المتكامل`,
      en: `${city} Integrated Sports Club`,
      ku: `یانەی وەرزشی گشتیی ${city}`,
    }),
    buildDescription: (city: string) => ({
      ar: `منشأة رياضية متكاملة تقدم برامج تدريبية مجتمعية في ${city}.`,
      en: `A community-driven sports complex offering multi-sport training programs in ${city}.`,
      ku: `کۆمپلەکسێکی وەرزشی بۆ کۆمەڵگا کە پرۆگرامەکانی جۆراوجۆری ڕاهێنان لە ${city} پێشکەش دەکات.`,
    }),
  },
  {
    type: 'academy' as FacilityType,
    photoSeed: 'academy',
    amenities: ['مختبر قياسات بدنية', 'سكن داخلي', 'قاعة محاضرات', 'ملاعب تدريب'],
    buildName: (city: string) => ({
      ar: `أكاديمية ${city} للموهوبين`,
      en: `${city} Elite Talent Academy`,
      ku: `ئەکادیمی تواناکانی ${city}`,
    }),
    buildDescription: (city: string) => ({
      ar: `أكاديمية متخصصة في اكتشاف وصقل المواهب الرياضية في محافظة ${city}.`,
      en: `A specialist academy dedicated to scouting and nurturing athletic talents in ${city}.`,
      ku: `ئەکادیمیاکی تایبەتمەند بۆ دۆزینەوە و پەرەسەندنی تواناکانی وەرزشی لە ${city}.`,
    }),
  },
  {
    type: 'forum' as FacilityType,
    photoSeed: 'forum',
    amenities: ['صالة مؤتمرات', 'مختبر حاسوب', 'مساحة عمل مشتركة', 'مكتبة رقمية'],
    buildName: (city: string) => ({
      ar: `منتدى شباب ${city}`,
      en: `${city} Youth Forum`,
      ku: `فۆڕەمی گەنجانی ${city}`,
    }),
    buildDescription: (city: string) => ({
      ar: `منتدى شبابي متعدد الاستخدامات يعزز الابتكار وريادة الأعمال في ${city}.`,
      en: `A multi-purpose youth forum empowering innovation and entrepreneurship initiatives in ${city}.`,
      ku: `فۆڕەمی گەنجان بۆ کاری جۆراوجۆر کە پێشەنگی و نوزەری لە ${city} پشتگیری دەکات.`,
    }),
  },
  {
    type: 'gym' as FacilityType,
    photoSeed: 'gym',
    amenities: ['أجهزة تدريب متقدمة', 'قسم تغذية', 'قاعة لياقة جماعية', 'مدربون معتمدون'],
    capacity: { min: 150, max: 450 },
    buildName: (city: string) => ({
      ar: `مركز ${city} المتطور للياقة`,
      en: `${city} Advanced Fitness Hub`,
      ku: `ناوەندی ھەستنەوەی پیشکەوتوی ${city}`,
    }),
    buildDescription: (city: string) => ({
      ar: `مركز لياقة بدنية يقدم تدريبًا متخصصًا وبرامج تغذية رياضية لسكان ${city}.`,
      en: `A fitness hub delivering specialized coaching and sports nutrition support for residents of ${city}.`,
      ku: `ناوەندی تەندروستی کە ڕاهێنانی تایبەتی و پشتگیری خواردنەوەی وەرزشی بۆ خەڵکی ${city} پێشکەش دەکات.`,
    }),
  },
  {
    type: 'pool' as FacilityType,
    photoSeed: 'pool',
    amenities: ['مسبح داخلي مُدفّأ', 'مدرسة سباحة', 'مدرجات للجمهور', 'وحدة إنقاذ متخصصة'],
    capacity: { min: 600, max: 1800 },
    buildName: (city: string) => ({
      ar: `مسبح ${city} الأولمبي`,
      en: `${city} Olympic Aquatic Center`,
      ku: `سەنتەری ئاوەکاری ئۆلۆمپیی ${city}`,
    }),
    buildDescription: (city: string) => ({
      ar: `مرفق سباحة بمعايير أولمبية يستضيف بطولات وفعاليات مجتمعية في ${city}.`,
      en: `An Olympic-spec aquatic center hosting competitions and community events in ${city}.`,
      ku: `سەنتەری ئاوەکاری بە ستانداردی ئۆلۆمپی کە پێشوازی ئەزموون و چالاکییە گشتییەکان لە ${city} دەکات.`,
    }),
  },
];

const randomInRange = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;

const scatterAroundCity = (lat: number, lng: number, slotIndex: number, totalSlots: number) => {
  const normalizedIndex = slotIndex % totalSlots;
  const angle = (normalizedIndex / totalSlots) * Math.PI * 2;
  const baseRadius = 0.025 + Math.random() * 0.035; // roughly 2.5km - 4.5km
  const latOffset = Math.cos(angle) * baseRadius;
  const lngOffset = Math.sin(angle) * baseRadius * Math.cos((lat * Math.PI) / 180);

  const microJitterLat = (Math.random() - 0.5) * 0.01;
  const microJitterLng = (Math.random() - 0.5) * 0.01;

  return {
    lat: lat + latOffset + microJitterLat,
    lng: lng + lngOffset + microJitterLng,
  };
};

export const facilities: Facility[] = iraqiCities.flatMap((city, idx) =>
  facilityTemplates.map((template, templateIdx) => {
    const { lat, lng } = scatterAroundCity(city.lat, city.lng, templateIdx + idx, facilityTemplates.length);
    const capacity = template.capacity
      ? randomInRange(template.capacity.min, template.capacity.max)
      : undefined;

    return {
      id: `facility-${idx * facilityTemplates.length + templateIdx + 1}`,
      name: template.buildName(city.city),
      type: template.type,
    province: city.province,
    city: city.city,
      lat,
      lng,
      photos: [`https://picsum.photos/seed/${template.photoSeed}${idx}/800/600`],
      description: template.buildDescription(city.city),
      capacity,
      amenities: template.amenities,
    createdAt: '2023-01-01T00:00:00Z',
    };
  }),
);

// Events
export const events: Event[] = [
  {
    id: 'event-1',
    titleAr: 'مهرجان الشباب العراقي السنوي 2025',
    titleEn: 'Annual Iraqi Youth Festival 2025',
    titleKu: 'فێستیڤاڵی ساڵانەی لاوانی عێراقی ٢٠٢٥',
    start: '2025-12-10T09:00:00Z',
    end: '2025-12-12T18:00:00Z',
    location: 'بغداد - قصر المؤتمرات',
    description: {
      ar: 'مهرجان سنوي يجمع الشباب العراقي من جميع المحافظات للاحتفال بالإنجازات وتبادل الخبرات والمشاركة في الأنشطة الثقافية والرياضية',
      en: 'Annual festival bringing together Iraqi youth from all governorates to celebrate achievements and exchange experiences',
      ku: 'فێستیڤاڵێکی ساڵانە کە گەنجانی عێراق لە هەموو پارێزگاکانەوە کۆدەکاتەوە بۆ ئاهەنگگێڕان بۆ دەستکەوتەکان',
    },
    category: 'festival',
    registrationRequired: true,
    maxParticipants: 500,
    currentParticipants: 235,
    image: 'https://picsum.photos/seed/festival1/800/600',
    organizerId: 'dept-2',
    createdAt: '2024-09-01T00:00:00Z',
  },
  {
    id: 'event-2',
    titleAr: 'ندوة الرياضة والصحة',
    titleEn: 'Sports and Health Seminar',
    titleKu: 'سیمیناری وەرزش و تەندروستی',
    start: '2025-11-20T10:00:00Z',
    end: '2025-11-20T16:00:00Z',
    location: 'البصرة - مركز الشباب',
    description: {
      ar: 'ندوة علمية حول أهمية الرياضة في الحياة الصحية وتأثيرها الإيجابي على المجتمع والأفراد',
      en: 'Scientific seminar on the importance of sports in healthy living',
      ku: 'سیمینارێکی زانستی دەربارەی گرنگی وەرزش لە ژیانی تەندروست',
    },
    category: 'seminar',
    registrationRequired: true,
    maxParticipants: 150,
    currentParticipants: 87,
    image: 'https://picsum.photos/seed/seminar1/800/600',
    organizerId: 'dept-1',
    createdAt: '2024-10-01T00:00:00Z',
  },
  {
    id: 'event-3',
    titleAr: 'مؤتمر تطوير القدرات الشبابية',
    titleEn: 'Youth Capacity Development Conference',
    titleKu: 'کۆنفرانسی گەشەپێدانی توانای گەنجان',
    start: '2025-11-28T09:00:00Z',
    end: '2025-11-30T17:00:00Z',
    location: 'أربيل - فندق روتانا',
    description: {
      ar: 'مؤتمر متخصص في تطوير قدرات الشباب العراقي وتأهيلهم لسوق العمل بمشاركة خبراء محليين ودوليين',
      en: 'Specialized conference on developing Iraqi youth capabilities and preparing them for the job market',
      ku: 'کۆنفرانسێکی تایبەت لە گەشەپێدانی توانای گەنجانی عێراقی',
    },
    category: 'conference',
    registrationRequired: true,
    maxParticipants: 300,
    currentParticipants: 145,
    image: 'https://picsum.photos/seed/conference2/800/600',
    organizerId: 'dept-2',
    createdAt: '2024-10-15T00:00:00Z',
  },
  {
    id: 'event-4',
    titleAr: 'بطولة العراق للألعاب الرياضية',
    titleEn: 'Iraq Sports Games Championship',
    titleKu: 'پاڵاوتنی یارییە وەرزشییەکانی عێراق',
    start: '2025-12-05T08:00:00Z',
    end: '2025-12-08T20:00:00Z',
    location: 'الموصل - الملعب الأولمبي',
    description: {
      ar: 'بطولة رياضية شاملة تجمع رياضيي العراق من مختلف المحافظات في منافسات متنوعة',
      en: 'Comprehensive sports championship gathering Iraqi athletes from various governorates',
      ku: 'پاڵاوتنێکی وەرزشی گشتگیر کە وەرزشوانانی عێراق کۆدەکاتەوە',
    },
    category: 'sport',
    registrationRequired: true,
    maxParticipants: 800,
    currentParticipants: 520,
    image: 'https://picsum.photos/seed/sports1/800/600',
    organizerId: 'dept-1',
    createdAt: '2024-10-20T00:00:00Z',
  },
  {
    id: 'event-5',
    titleAr: 'دورة تدريبية للمدربين الرياضيين',
    titleEn: 'Sports Coaches Training Course',
    titleKu: 'خولی ڕاهێنان بۆ ڕاهێنەرە وەرزشییەکان',
    start: '2025-11-25T09:00:00Z',
    end: '2025-11-27T17:00:00Z',
    location: 'بغداد - مركز التدريب الرياضي',
    description: {
      ar: 'دورة تدريبية متقدمة للمدربين الرياضيين بإشراف خبراء دوليين لتطوير المهارات التدريبية',
      en: 'Advanced training course for sports coaches supervised by international experts',
      ku: 'خولێکی ڕاهێنانی پێشکەوتوو بۆ ڕاهێنەرە وەرزشییەکان',
    },
    category: 'training',
    registrationRequired: true,
    maxParticipants: 100,
    currentParticipants: 68,
    image: 'https://picsum.photos/seed/training2/800/600',
    organizerId: 'dept-1',
    createdAt: '2024-10-25T00:00:00Z',
  },
  {
    id: 'event-6',
    titleAr: 'منتدى الشباب والابتكار',
    titleEn: 'Youth and Innovation Forum',
    titleKu: 'فۆرمی گەنجان و داهێنان',
    start: '2025-12-15T10:00:00Z',
    end: '2025-12-16T18:00:00Z',
    location: 'السليمانية - مركز الثقافة',
    description: {
      ar: 'منتدى يجمع الشباب المبتكرين لعرض مشاريعهم وأفكارهم الإبداعية في مجالات مختلفة',
      en: 'Forum bringing together innovative youth to showcase their creative projects and ideas',
      ku: 'فۆرمێک کە گەنجە داهێنەرەکان کۆدەکاتەوە',
    },
    category: 'conference',
    registrationRequired: true,
    maxParticipants: 200,
    currentParticipants: 95,
    image: 'https://picsum.photos/seed/innovation1/800/600',
    organizerId: 'dept-2',
    createdAt: '2024-10-28T00:00:00Z',
  },
];

// Form Schemas
export const formSchemas: FormSchema[] = [
  {
    id: 'form-complaints',
    title: {
      ar: 'نموذج شؤون المواطنيين',
      en: 'Complaints Form',
      ku: 'فۆرمی گلەیی',
    },
    description: {
      ar: 'نموذج تقديم الاستفسارات للمواطنين',
      en: 'Form for submitting complaints and inquiries',
      ku: 'فۆرم بۆ پێشکەشکردنی گلەیی و پرسیار',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        placeholder: { ar: 'أدخل اسمك الكامل', en: 'Enter your full name', ku: 'ناوی تەواوت بنووسە' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'text',
        label: { ar: 'رقم الهوية الوطنية', en: 'National ID', ku: 'ژمارەی ناسنامە' },
        required: true,
        validation: {
          pattern: '^\\d{12}$',
          message: { ar: '12 رقماً', en: '12 digits', ku: '١٢ ژمارە' },
        },
      },
      {
        id: 'field-3',
        type: 'email',
        label: { ar: 'البريد الإلكتروني', en: 'Email', ku: 'ئیمەیڵ' },
        required: true,
      },
      {
        id: 'field-4',
        type: 'phone',
        label: { ar: 'رقم الهاتف', en: 'Phone', ku: 'تەلەفۆن' },
        required: true,
      },
      {
        id: 'field-5',
        type: 'text',
        label: { ar: 'الموضوع', en: 'Subject', ku: 'بابەت' },
        required: true,
      },
      {
        id: 'field-6',
        type: 'textarea',
        label: { ar: 'تفاصيل الشكوى', en: 'Complaint Details', ku: 'وردەکارییەکانی گلەیی' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['complaints@moys.gov.iq'],
      whatsappTo: ['+964770123456'],
      smsTo: ['+964770123456'],
    },
    isExam: false,
    active: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'form-exam-sample',
    title: {
      ar: 'اختبار تجريبي',
      en: 'Sample Test',
      ku: 'تاقیکردنەوەی نموونە',
    },
    description: {
      ar: 'اختبار تجريبي مع نظام التقييم',
      en: 'Sample test with scoring system',
      ku: 'تاقیکردنەوەیەکی نموونە بە سیستەمی نمرەدان',
    },
    fields: [
      {
        id: 'q1',
        type: 'radio',
        label: { ar: 'متى تأسست وزارة الشباب والرياضة؟', en: 'When was the Ministry established?', ku: 'کەی وەزارەت دامەزرا؟' },
        required: true,
        options: [
          { value: 'a', label: { ar: '2003', en: '2003', ku: '2003' } },
          { value: 'b', label: { ar: '2005', en: '2005', ku: '2005' } },
          { value: 'c', label: { ar: '2010', en: '2010', ku: '2010' } },
        ],
        score: 10,
      },
      {
        id: 'q2',
        type: 'checkbox',
        label: { ar: 'ما هي أهداف الوزارة؟ (اختر الصحيح)', en: 'What are the ministry goals?', ku: 'ئامانجی وەزارەت چییە؟' },
        required: true,
        options: [
          { value: 'a', label: { ar: 'تطوير الرياضة', en: 'Sports development', ku: 'گەشەپێدانی وەرزش' } },
          { value: 'b', label: { ar: 'تمكين الشباب', en: 'Youth empowerment', ku: 'بەهێزکردنی گەنجان' } },
          { value: 'c', label: { ar: 'بيع المعدات', en: 'Selling equipment', ku: 'فرۆشتنی کەلوپەل' } },
        ],
        score: 15,
      },
    ],
    notifications: {
      emailTo: ['exams@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: true,
    passingScore: 15,
    active: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'form-sports-registration',
    title: {
      ar: 'نموذج التسجيل في النوادي الرياضية',
      en: 'Sports Club Registration Form',
      ku: 'فۆرمی تۆمارکردن لە یانەی وەرزشیدا',
    },
    description: {
      ar: 'نموذج تسجيل الأعضاء الجدد في النوادي الرياضية المعتمدة',
      en: 'Registration form for new members in accredited sports clubs',
      ku: 'فۆرمی تۆمارکردنی ئەندامانی نوێ لە یانە وەرزشییەکان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'date',
        label: { ar: 'تاريخ الميلاد', en: 'Date of Birth', ku: 'ڕێکەوتی لەدایکبوون' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'النادي الرياضي', en: 'Sports Club', ku: 'یانەی وەرزشی' },
        options: [
          { value: 'football', label: { ar: 'كرة القدم', en: 'Football', ku: 'تۆپی پێ' } },
          { value: 'basketball', label: { ar: 'كرة السلة', en: 'Basketball', ku: 'تۆپی سەبەتە' } },
          { value: 'swimming', label: { ar: 'السباحة', en: 'Swimming', ku: 'مەلەکردن' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['sports@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-02-15T00:00:00Z',
    updatedAt: '2024-02-15T00:00:00Z',
  },
  {
    id: 'form-volunteer',
    title: {
      ar: 'نموذج التطوع',
      en: 'Volunteer Registration Form',
      ku: 'فۆرمی دڵخوازانە',
    },
    description: {
      ar: 'سجل الآن للانضمام إلى برامج التطوع في الوزارة',
      en: 'Register now to join ministry volunteer programs',
      ku: 'ئێستا تۆمار بکە بۆ بەشداریکردن لە پرۆگرامی دڵخوازانە',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'email',
        label: { ar: 'البريد الإلكتروني', en: 'Email', ku: 'ئیمەیڵ' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'phone',
        label: { ar: 'رقم الهاتف', en: 'Phone', ku: 'تەلەفۆن' },
        required: true,
      },
      {
        id: 'field-4',
        type: 'select',
        label: { ar: 'مجال التطوع', en: 'Volunteer Field', ku: 'بوارەی دڵخوازانە' },
        options: [
          { value: 'events', label: { ar: 'تنظيم الفعاليات', en: 'Event Organization', ku: 'ڕێکخستنی بۆنە' } },
          { value: 'coaching', label: { ar: 'التدريب الرياضي', en: 'Sports Coaching', ku: 'ڕاهێنانی وەرزشی' } },
          { value: 'admin', label: { ar: 'الدعم الإداري', en: 'Administrative Support', ku: 'پشتگیری کارگێڕی' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['volunteer@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-03-01T00:00:00Z',
    updatedAt: '2024-03-01T00:00:00Z',
  },
  {
    id: 'form-facility-booking',
    title: {
      ar: 'نموذج حجز المنشآت الرياضية',
      en: 'Sports Facility Booking Form',
      ku: 'فۆرمی نۆرەکردنی شوێنە وەرزشییەکان',
    },
    description: {
      ar: 'احجز الملاعب والصالات الرياضية للفعاليات والأنشطة',
      en: 'Book sports fields and halls for events and activities',
      ku: 'یاریگا و هۆڵی وەرزشی نۆرە بکە بۆ چالاکی',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'اسم الجهة', en: 'Organization Name', ku: 'ناوی ڕێکخراو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'نوع المنشأة', en: 'Facility Type', ku: 'جۆری شوێن' },
        options: [
          { value: 'stadium', label: { ar: 'ملعب', en: 'Stadium', ku: 'یاریگا' } },
          { value: 'hall', label: { ar: 'صالة رياضية', en: 'Sports Hall', ku: 'هۆڵی وەرزشی' } },
          { value: 'pool', label: { ar: 'مسبح', en: 'Swimming Pool', ku: 'حەوزی مەلەکردن' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'date',
        label: { ar: 'تاريخ الحجز', en: 'Booking Date', ku: 'ڕێکەوتی نۆرە' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['facilities@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-03-10T00:00:00Z',
    updatedAt: '2024-03-10T00:00:00Z',
  },
  {
    id: 'form-scholarship',
    title: {
      ar: 'نموذج طلب المنحة الرياضية',
      en: 'Sports Scholarship Application',
      ku: 'فۆرمی داواکاری بورسی وەرزشی',
    },
    description: {
      ar: 'قدم طلبك للحصول على منحة رياضية للموهوبين',
      en: 'Apply for sports scholarship for talented athletes',
      ku: 'داوای بورسی وەرزشی بکە بۆ وەرزشوانانی بەهرەدار',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'نوع الرياضة', en: 'Sport Type', ku: 'جۆری وەرزش' },
        options: [
          { value: 'football', label: { ar: 'كرة القدم', en: 'Football', ku: 'تۆپی پێ' } },
          { value: 'athletics', label: { ar: 'ألعاب القوى', en: 'Athletics', ku: 'وەرزشی کێبڕکێ' } },
          { value: 'swimming', label: { ar: 'السباحة', en: 'Swimming', ku: 'مەلەکردن' } },
          { value: 'boxing', label: { ar: 'الملاكمة', en: 'Boxing', ku: 'موشتزدن' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'file',
        label: { ar: 'الإنجازات والشهادات', en: 'Achievements & Certificates', ku: 'دەستکەوت و بڕوانامەکان' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['scholarships@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-03-20T00:00:00Z',
    updatedAt: '2024-03-20T00:00:00Z',
  },
  {
    id: 'form-coach-license',
    title: {
      ar: 'نموذج طلب رخصة التدريب',
      en: 'Coaching License Application',
      ku: 'فۆرمی داواکاری مۆڵەتی ڕاهێنان',
    },
    description: {
      ar: 'تقدم بطلب للحصول على رخصة التدريب الرياضي المعتمدة',
      en: 'Apply for accredited sports coaching license',
      ku: 'داوای مۆڵەتی ڕاهێنانی وەرزشی پەسەندکراو بکە',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'مستوى الرخصة', en: 'License Level', ku: 'ئاستی مۆڵەت' },
        options: [
          { value: 'c', label: { ar: 'رخصة C', en: 'C License', ku: 'مۆڵەتی C' } },
          { value: 'b', label: { ar: 'رخصة B', en: 'B License', ku: 'مۆڵەتی B' } },
          { value: 'a', label: { ar: 'رخصة A', en: 'A License', ku: 'مۆڵەتی A' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'number',
        label: { ar: 'سنوات الخبرة', en: 'Years of Experience', ku: 'ساڵانی ئەزموون' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['coaching@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2024-04-01T00:00:00Z',
  },
  {
    id: 'form-youth-program',
    title: {
      ar: 'نموذج الانضمام لبرامج الشباب',
      en: 'Youth Programs Enrollment Form',
      ku: 'فۆرمی بەشداریکردن لە پرۆگرامی گەنجان',
    },
    description: {
      ar: 'انضم إلى برامج تطوير مهارات الشباب والتدريب المهني',
      en: 'Join youth skills development and vocational training programs',
      ku: 'بەشداری بکە لە پرۆگرامی گەشەپێدانی لێهاتووی و ڕاهێنانی پیشەیی',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'number',
        label: { ar: 'العمر', en: 'Age', ku: 'تەمەن' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'البرنامج المطلوب', en: 'Desired Program', ku: 'پرۆگرامی داواکراو' },
        options: [
          { value: 'leadership', label: { ar: 'القيادة والإدارة', en: 'Leadership & Management', ku: 'ڕابەری و بەڕێوەبردن' } },
          { value: 'tech', label: { ar: 'التقنية والحاسوب', en: 'Technology & Computing', ku: 'تەکنەلۆژیا و کۆمپیوتەر' } },
          { value: 'business', label: { ar: 'ريادة الأعمال', en: 'Entrepreneurship', ku: 'سەرکەوتن لە بازرگانی' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['youth@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-04-15T00:00:00Z',
    updatedAt: '2024-04-15T00:00:00Z',
  },
  {
    id: 'form-talent-showcase',
    title: {
      ar: 'نموذج عرض المواهب',
      en: 'Talent Showcase Form',
      ku: 'فۆرمی پیشاندانی بەهرە',
    },
    description: {
      ar: 'شارك موهبتك في الفن أو العلوم أو الرياضة',
      en: 'Showcase your talent in arts, sciences, or sports',
      ku: 'بەهرەکەت لە هونەر، زانست، یان وەرزش پیشان بدە',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم', en: 'Name', ku: 'ناو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'نوع الموهبة', en: 'Talent Type', ku: 'جۆری بەهرە' },
        options: [
          { value: 'art', label: { ar: 'فني', en: 'Artistic', ku: 'هونەری' } },
          { value: 'science', label: { ar: 'علمي', en: 'Scientific', ku: 'زانستی' } },
          { value: 'sport', label: { ar: 'رياضي', en: 'Athletic', ku: 'وەرزشی' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'textarea',
        label: { ar: 'وصف الموهبة', en: 'Talent Description', ku: 'وەسفی بەهرە' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['talents@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-05-01T00:00:00Z',
    updatedAt: '2024-05-01T00:00:00Z',
  },
  {
    id: 'form-security-clearance',
    title: {
      ar: 'نموذج طلب التخليص الأمني',
      en: 'Security Clearance Request Form',
      ku: 'فۆرمی داواکاری پاکتاوکردنی ئەمنی',
    },
    description: {
      ar: 'تقديم طلب الحصول على التخليص الأمني للعاملين',
      en: 'Submit security clearance request for employees',
      ku: 'داواکاری پاکتاوکردنی ئەمنی پێشکەش بکە بۆ کارمەندان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'text',
        label: { ar: 'رقم الهوية', en: 'ID Number', ku: 'ژمارەی ناسنامە' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'الدائرة', en: 'Department', ku: 'بەش' },
        options: [
          { value: 'sports', label: { ar: 'الرياضة', en: 'Sports', ku: 'وەرزش' } },
          { value: 'youth', label: { ar: 'الشباب', en: 'Youth', ku: 'گەنجان' } },
          { value: 'admin', label: { ar: 'الإدارة', en: 'Administration', ku: 'بەڕێوەبردن' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['security@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-05-15T00:00:00Z',
    updatedAt: '2024-05-15T00:00:00Z',
  },
  {
    id: 'form-women-sports',
    title: {
      ar: 'نموذج تسجيل الرياضيات',
      en: 'Female Athletes Registration',
      ku: 'فۆرمی تۆمارکردنی وەرزشوانی ژن',
    },
    description: {
      ar: 'نموذج خاص بتسجيل الرياضيات في البرامج الرياضية النسائية',
      en: 'Special form for female athletes registration in women sports programs',
      ku: 'فۆرمی تایبەت بۆ تۆمارکردنی وەرزشوانی ژن لە پرۆگرامی وەرزشی ژنان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'date',
        label: { ar: 'تاريخ الميلاد', en: 'Date of Birth', ku: 'ڕێکەوتی لەدایکبوون' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'التخصص الرياضي', en: 'Sports Specialty', ku: 'پسپۆڕیی وەرزشی' },
        options: [
          { value: 'athletics', label: { ar: 'ألعاب القوى', en: 'Athletics', ku: 'وەرزشی کێبڕکێ' } },
          { value: 'volleyball', label: { ar: 'الكرة الطائرة', en: 'Volleyball', ku: 'تۆپی باڵا' } },
          { value: 'tennis', label: { ar: 'التنس', en: 'Tennis', ku: 'تێنس' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['women-sports@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-06-01T00:00:00Z',
    updatedAt: '2024-06-01T00:00:00Z',
  },
  {
    id: 'form-special-needs',
    title: {
      ar: 'نموذج برامج ذوي الاحتياجات الخاصة',
      en: 'Special Needs Programs Form',
      ku: 'فۆرمی پرۆگرامی خاوەن پێداویستی تایبەت',
    },
    description: {
      ar: 'سجل في برامج الرياضة والأنشطة لذوي الاحتياجات الخاصة',
      en: 'Register for sports and activities programs for people with special needs',
      ku: 'تۆمار بکە لە پرۆگرامی وەرزش و چالاکی بۆ خاوەن پێداویستی تایبەت',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'نوع البرنامج', en: 'Program Type', ku: 'جۆری پرۆگرام' },
        options: [
          { value: 'sports', label: { ar: 'برامج رياضية', en: 'Sports Programs', ku: 'پرۆگرامی وەرزشی' } },
          { value: 'social', label: { ar: 'أنشطة اجتماعية', en: 'Social Activities', ku: 'چالاکی کۆمەڵایەتی' } },
          { value: 'training', label: { ar: 'تدريب مهني', en: 'Vocational Training', ku: 'ڕاهێنانی پیشەیی' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'textarea',
        label: { ar: 'الاحتياجات الخاصة', en: 'Special Requirements', ku: 'پێداویستی تایبەت' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['special-needs@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-06-15T00:00:00Z',
    updatedAt: '2024-06-15T00:00:00Z',
  },
  {
    id: 'form-partnership',
    title: {
      ar: 'نموذج طلب الشراكة',
      en: 'Partnership Request Form',
      ku: 'فۆرمی داواکاری هاوبەشی',
    },
    description: {
      ar: 'قدم طلب شراكة مع الوزارة للمؤسسات والجهات',
      en: 'Submit partnership request for organizations and entities',
      ku: 'داواکاری هاوبەشی لەگەڵ وەزارەت پێشکەش بکە',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'اسم المؤسسة', en: 'Organization Name', ku: 'ناوی ڕێکخراو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'email',
        label: { ar: 'البريد الإلكتروني', en: 'Email', ku: 'ئیمەیڵ' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'نوع الشراكة', en: 'Partnership Type', ku: 'جۆری هاوبەشی' },
        options: [
          { value: 'sponsorship', label: { ar: 'رعاية', en: 'Sponsorship', ku: 'پشتگیری دارایی' } },
          { value: 'training', label: { ar: 'تدريب', en: 'Training', ku: 'ڕاهێنان' } },
          { value: 'facilities', label: { ar: 'منشآت', en: 'Facilities', ku: 'شوێنەکان' } },
        ],
        required: true,
      },
      {
        id: 'field-4',
        type: 'textarea',
        label: { ar: 'تفاصيل الشراكة المقترحة', en: 'Proposed Partnership Details', ku: 'وردەکاریی هاوبەشی پێشنیارکراو' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['partnerships@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-07-01T00:00:00Z',
    updatedAt: '2024-07-01T00:00:00Z',
  },
  {
    id: 'form-event-proposal',
    title: {
      ar: 'نموذج اقتراح فعالية',
      en: 'Event Proposal Form',
      ku: 'فۆرمی پێشنیاری بۆنە',
    },
    description: {
      ar: 'اقترح فعالية رياضية أو شبابية لتنظيمها تحت رعاية الوزارة',
      en: 'Propose sports or youth event to be organized under ministry sponsorship',
      ku: 'بۆنەی وەرزشی یان گەنجان پێشنیار بکە بۆ ڕێکخستن لەژێر چاودێری وەزارەت',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'اسم الفعالية', en: 'Event Name', ku: 'ناوی بۆنە' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'نوع الفعالية', en: 'Event Type', ku: 'جۆری بۆنە' },
        options: [
          { value: 'tournament', label: { ar: 'بطولة', en: 'Tournament', ku: 'پاڵاوتن' } },
          { value: 'conference', label: { ar: 'مؤتمر', en: 'Conference', ku: 'کۆنفرانس' } },
          { value: 'workshop', label: { ar: 'ورشة عمل', en: 'Workshop', ku: 'وۆرکشۆپ' } },
          { value: 'exhibition', label: { ar: 'معرض', en: 'Exhibition', ku: 'پیشانگا' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'date',
        label: { ar: 'التاريخ المقترح', en: 'Proposed Date', ku: 'ڕێکەوتی پێشنیارکراو' },
        required: true,
      },
      {
        id: 'field-4',
        type: 'number',
        label: { ar: 'عدد المشاركين المتوقع', en: 'Expected Participants', ku: 'ژمارەی بەشداربووانی چاوەڕوانکراو' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['events@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-07-15T00:00:00Z',
    updatedAt: '2024-07-15T00:00:00Z',
  },
  {
    id: 'form-equipment-request',
    title: {
      ar: 'نموذج طلب المعدات الرياضية',
      en: 'Sports Equipment Request Form',
      ku: 'فۆرمی داواکاری کەلوپەلی وەرزشی',
    },
    description: {
      ar: 'طلب معدات رياضية للنوادي والمدارس المعتمدة',
      en: 'Request sports equipment for accredited clubs and schools',
      ku: 'داواکاری کەلوپەلی وەرزشی بکە بۆ یانە و قوتابخانە پەسەندکراوەکان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'اسم النادي/المدرسة', en: 'Club/School Name', ku: 'ناوی یانە/قوتابخانە' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'نوع المعدات', en: 'Equipment Type', ku: 'جۆری کەلوپەل' },
        options: [
          { value: 'football', label: { ar: 'معدات كرة القدم', en: 'Football Equipment', ku: 'کەلوپەلی تۆپی پێ' } },
          { value: 'basketball', label: { ar: 'معدات كرة السلة', en: 'Basketball Equipment', ku: 'کەلوپەلی تۆپی سەبەتە' } },
          { value: 'athletics', label: { ar: 'معدات ألعاب القوى', en: 'Athletics Equipment', ku: 'کەلوپەلی کێبڕکێ' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'number',
        label: { ar: 'الكمية المطلوبة', en: 'Quantity Required', ku: 'بڕی پێویست' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['equipment@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-08-01T00:00:00Z',
    updatedAt: '2024-08-01T00:00:00Z',
  },
  {
    id: 'form-referee-license',
    title: {
      ar: 'نموذج طلب رخصة التحكيم',
      en: 'Referee License Application',
      ku: 'فۆرمی داواکاری مۆڵەتی ناوبژیوانی',
    },
    description: {
      ar: 'تقدم للحصول على رخصة التحكيم الرياضي المعتمدة',
      en: 'Apply for accredited sports referee license',
      ku: 'داوای مۆڵەتی ناوبژیوانی وەرزشی پەسەندکراو بکە',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'select',
        label: { ar: 'الرياضة', en: 'Sport', ku: 'وەرزش' },
        options: [
          { value: 'football', label: { ar: 'كرة القدم', en: 'Football', ku: 'تۆپی پێ' } },
          { value: 'basketball', label: { ar: 'كرة السلة', en: 'Basketball', ku: 'تۆپی سەبەتە' } },
          { value: 'volleyball', label: { ar: 'كرة الطائرة', en: 'Volleyball', ku: 'تۆپی باڵا' } },
        ],
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'مستوى الرخصة', en: 'License Level', ku: 'ئاستی مۆڵەت' },
        options: [
          { value: 'local', label: { ar: 'محلي', en: 'Local', ku: 'ناوخۆیی' } },
          { value: 'national', label: { ar: 'وطني', en: 'National', ku: 'نیشتمانی' } },
          { value: 'international', label: { ar: 'دولي', en: 'International', ku: 'نێودەوڵەتی' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['refereeing@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-08-15T00:00:00Z',
    updatedAt: '2024-08-15T00:00:00Z',
  },
  {
    id: 'form-media-accreditation',
    title: {
      ar: 'نموذج اعتماد الإعلاميين',
      en: 'Media Accreditation Form',
      ku: 'فۆرمی پەسەندکردنی میدیا',
    },
    description: {
      ar: 'طلب اعتماد إعلامي لتغطية الفعاليات الرياضية',
      en: 'Request media accreditation to cover sports events',
      ku: 'داواکاری پەسەندکردنی میدیا بۆ ڕاپۆرتکردنی بۆنە وەرزشییەکان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'اسم الإعلامي', en: 'Media Name', ku: 'ناوی میدیا' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'text',
        label: { ar: 'المؤسسة الإعلامية', en: 'Media Organization', ku: 'ڕێکخراوی میدیا' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'نوع الوسيلة', en: 'Media Type', ku: 'جۆری میدیا' },
        options: [
          { value: 'tv', label: { ar: 'تلفزيون', en: 'Television', ku: 'تەلەفزیۆن' } },
          { value: 'radio', label: { ar: 'إذاعة', en: 'Radio', ku: 'ڕادیۆ' } },
          { value: 'newspaper', label: { ar: 'صحيفة', en: 'Newspaper', ku: 'ڕۆژنامە' } },
          { value: 'online', label: { ar: 'إعلام رقمي', en: 'Digital Media', ku: 'میدیای دیجیتاڵ' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['media@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-09-01T00:00:00Z',
    updatedAt: '2024-09-01T00:00:00Z',
  },
  {
    id: 'form-internship',
    title: {
      ar: 'نموذج طلب التدريب',
      en: 'Internship Application Form',
      ku: 'فۆرمی داواکاری ڕاهێنان',
    },
    description: {
      ar: 'تقدم بطلب للتدريب في دوائر الوزارة للطلاب والخريجين',
      en: 'Apply for internship in ministry departments for students and graduates',
      ku: 'داوای ڕاهێنان لە بەشەکانی وەزارەت بکە بۆ خوێندکار و دەرچووان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'الاسم الكامل', en: 'Full Name', ku: 'ناوی تەواو' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'text',
        label: { ar: 'الجامعة/الكلية', en: 'University/College', ku: 'زانکۆ/کۆلێژ' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'select',
        label: { ar: 'الدائرة المطلوبة', en: 'Desired Department', ku: 'بەشی داواکراو' },
        options: [
          { value: 'sports', label: { ar: 'الرياضة', en: 'Sports', ku: 'وەرزش' } },
          { value: 'youth', label: { ar: 'الشباب', en: 'Youth', ku: 'گەنجان' } },
          { value: 'media', label: { ar: 'الإعلام', en: 'Media', ku: 'میدیا' } },
          { value: 'admin', label: { ar: 'الإدارة', en: 'Administration', ku: 'بەڕێوەبردن' } },
        ],
        required: true,
      },
      {
        id: 'field-4',
        type: 'date',
        label: { ar: 'تاريخ البدء المفضل', en: 'Preferred Start Date', ku: 'ڕێکەوتی دەستپێکی خوازراو' },
        required: true,
      },
    ],
    notifications: {
      emailTo: ['hr@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-09-15T00:00:00Z',
    updatedAt: '2024-09-15T00:00:00Z',
  },
  {
    id: 'form-stadium-tour',
    title: {
      ar: 'نموذج حجز جولة في الملاعب',
      en: 'Stadium Tour Booking Form',
      ku: 'فۆرمی نۆرەکردنی گەشتی یاریگا',
    },
    description: {
      ar: 'احجز جولة إرشادية في الملاعب والمنشآت الرياضية',
      en: 'Book guided tour of stadiums and sports facilities',
      ku: 'گەشتی ڕێنمایی نۆرە بکە لە یاریگا و شوێنە وەرزشییەکان',
    },
    fields: [
      {
        id: 'field-1',
        type: 'text',
        label: { ar: 'اسم المجموعة', en: 'Group Name', ku: 'ناوی گرووپ' },
        required: true,
      },
      {
        id: 'field-2',
        type: 'number',
        label: { ar: 'عدد الأشخاص', en: 'Number of People', ku: 'ژمارەی کەسان' },
        required: true,
      },
      {
        id: 'field-3',
        type: 'date',
        label: { ar: 'تاريخ الجولة', en: 'Tour Date', ku: 'ڕێکەوتی گەشت' },
        required: true,
      },
      {
        id: 'field-4',
        type: 'select',
        label: { ar: 'الملعب', en: 'Stadium', ku: 'یاریگا' },
        options: [
          { value: 'stadium1', label: { ar: 'ملعب الشعب الدولي', en: 'Al-Shaab Stadium', ku: 'یاریگای نێودەوڵەتی الشعب' } },
          { value: 'stadium2', label: { ar: 'ملعب البصرة الدولي', en: 'Basra Stadium', ku: 'یاریگای نێودەوڵەتی بەسرە' } },
        ],
        required: true,
      },
    ],
    notifications: {
      emailTo: ['tours@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: false,
    active: true,
    createdAt: '2024-10-01T00:00:00Z',
    updatedAt: '2024-10-01T00:00:00Z',
  },
  {
    id: 'form-fitness-test',
    title: {
      ar: 'اختبار اللياقة البدنية',
      en: 'Physical Fitness Test',
      ku: 'تاقیکردنەوەی تەندروستی جەستەیی',
    },
    description: {
      ar: 'اختبار تقييم اللياقة البدنية للرياضيين',
      en: 'Physical fitness assessment test for athletes',
      ku: 'تاقیکردنەوەی هەڵسەنگاندنی تەندروستی جەستەیی بۆ وەرزشوانان',
    },
    fields: [
      {
        id: 'q1',
        type: 'number',
        label: { ar: 'كم مرة تمارس الرياضة أسبوعياً؟', en: 'How many times do you exercise weekly?', ku: 'چەند جار لە هەفتەیەکدا وەرزش دەکەیت؟' },
        required: true,
        score: 5,
      },
      {
        id: 'q2',
        type: 'radio',
        label: { ar: 'هل تتبع نظام غذائي صحي؟', en: 'Do you follow a healthy diet?', ku: 'ئایا خۆراکی تەندروست دەخۆیت؟' },
        options: [
          { value: 'yes', label: { ar: 'نعم', en: 'Yes', ku: 'بەڵێ' } },
          { value: 'no', label: { ar: 'لا', en: 'No', ku: 'نەخێر' } },
        ],
        required: true,
        score: 5,
      },
    ],
    notifications: {
      emailTo: ['fitness@moys.gov.iq'],
      whatsappTo: [],
      smsTo: [],
    },
    isExam: true,
    passingScore: 7,
    active: true,
    createdAt: '2024-10-15T00:00:00Z',
    updatedAt: '2024-10-15T00:00:00Z',
  },
];

// Talents
export const talents: Talent[] = [
  {
    id: 'talent-1',
    name: 'أحمد حسين الجبوري',
    category: 'sport',
    bioAr: 'بطل عراقي في ألعاب القوى، حاصل على الميدالية الذهبية في بطولة آسيا 2024 والميدالية البرونزية في البطولة العربية',
    bioEn: 'Iraqi athletics champion, won gold medal in Asia Championship 2024',
    bioKu: 'پاڵەوانی عێراقی وەرزشی، وەرگری مەدالیای زێڕین لە پاڵاوتنی ئاسیا ٢٠٢٤',
    photo: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1200&auto=format&fit=crop',
    achievements: {
      ar: 'ميدالية ذهبية - بطولة آسيا 2024',
      en: 'Gold Medal - Asia Championship 2024',
      ku: 'مەدالیای زێڕین - پاڵاوتنی ئاسیا ٢٠٢٤',
    },
    socialMedia: {
      facebook: 'https://facebook.com/ahmed.athletics',
      instagram: 'https://instagram.com/ahmed.athletics',
    },
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'talent-2',
    name: 'د. سارة علي الموسوي',
    category: 'science',
    bioAr: 'باحثة عراقية في مجال الفيزياء النووية، حاصلة على جائزة التميز العلمي من جامعة بغداد ومنحة دراسية دولية',
    bioEn: 'Iraqi researcher in nuclear physics, received Scientific Excellence Award',
    bioKu: 'توێژەری عێراقی لە بواری فیزیای ناوکی، وەرگری خەڵاتی تایبەتمەندی زانستی',
    photo: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1200&auto=format&fit=crop',
    achievements: {
      ar: 'جائزة التميز العلمي 2024',
      en: 'Scientific Excellence Award 2024',
      ku: 'خەڵاتی تایبەتمەندی زانستی ٢٠٢٤',
    },
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'talent-3',
    name: 'محمد كريم النجار',
    category: 'art',
    bioAr: 'رسام عراقي موهوب فاز بجائزة أفضل لوحة فنية في المعرض العربي للفنون التشكيلية وشارك في عدة معارض دولية',
    bioEn: 'Talented Iraqi painter, won Best Painting Award at Arab Art Exhibition',
    bioKu: 'وێنەکێشێکی بەهرەداری عێراقی، وەرگری خەڵاتی باشترین تابلۆ',
    photo: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=1200&auto=format&fit=crop',
    achievements: {
      ar: 'جائزة أفضل لوحة - المعرض العربي 2024',
      en: 'Best Painting Award - Arab Exhibition 2024',
      ku: 'خەڵاتی باشترین تابلۆ ٢٠٢٤',
    },
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'talent-4',
    name: 'فاطمة خالد',
    category: 'sport',
    bioAr: 'بطلة عراقية في السباحة، حطمت الرقم القياسي العراقي مرتين وتمثل العراق في البطولات الدولية',
    bioEn: 'Iraqi swimming champion, broke Iraqi record twice and represents Iraq internationally',
    bioKu: 'پاڵەوانی عێراقی مەلەوانگە، دوو جار ڕیکۆردی عێراقی شکاند',
    photo: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=1200&auto=format&fit=crop',
    achievements: {
      ar: 'رقم قياسي عراقي - السباحة 2024',
      en: 'Iraqi Record - Swimming 2024',
      ku: 'ڕیکۆردی عێراقی - مەلەوانگە ٢٠٢٤',
    },
    createdAt: '2024-02-01T00:00:00Z',
  },
  {
    id: 'talent-5',
    name: 'علي رضا الكعبي',
    category: 'science',
    bioAr: 'مبرمج عراقي شاب حاصل على جوائز دولية في مجال الذكاء الاصطناعي وتطوير التطبيقات',
    bioEn: 'Young Iraqi programmer, won international awards in AI and app development',
    bioKu: 'بەرنامەسازێکی گەنجی عێراقی، وەرگری خەڵاتی نێودەوڵەتی',
    photo: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200&auto=format&fit=crop',
    achievements: {
      ar: 'جائزة الابتكار في الذكاء الاصطناعي 2024',
      en: 'AI Innovation Award 2024',
      ku: 'خەڵاتی داهێنان لە زیرەکی دەستکرد ٢٠٢٤',
    },
    createdAt: '2024-03-01T00:00:00Z',
  },
  {
    id: 'talent-6',
    name: 'مريم عباس',
    category: 'art',
    bioAr: 'عازفة بيانو عراقية موهوبة، قدمت حفلات في عدة دول عربية وأوروبية وحاصلة على جوائز موسيقية',
    bioEn: 'Talented Iraqi pianist, performed in several Arab and European countries',
    bioKu: 'ژەنێکی بەهرەداری پیانۆی عێراقی، ئاهەنگی لە چەند وڵاتێکدا پێشکەش کردووە',
    photo: 'https://images.unsplash.com/photo-1513883049090-d0b7439799bf?q=80&w=1200&auto=format&fit=crop',
    achievements: {
      ar: 'جائزة أفضل عازف - المهرجان الموسيقي 2024',
      en: 'Best Performer Award - Music Festival 2024',
      ku: 'خەڵاتی باشترین ژەن ٢٠٢٤',
    },
    createdAt: '2024-04-01T00:00:00Z',
  },
];

// Subsites
export const subsites: Subsite[] = [
  {
    id: 'subsite-1',
    titleAr: 'اللجنة الأولمبية العراقية',
    titleEn: 'Iraqi Olympic Committee',
    titleKu: 'لیژنەی ئۆلیمپی عێراقی',
    url: 'https://iraqnoc.org',
    descriptionAr: 'الموقع الرسمي للجنة الأولمبية العراقية',
    descriptionEn: 'Official website of Iraqi Olympic Committee',
    descriptionKu: 'ماڵپەڕی فەرمیی لیژنەی ئۆلیمپی عێراقی',
    category: 'رياضة',
    active: true,
  },
  {
    id: 'subsite-2',
    titleAr: 'الاتحاد العراقي لكرة القدم',
    titleEn: 'Iraq Football Association',
    titleKu: 'یەکێتی تۆپی پێی عێراق',
    url: 'https://ifa.iq',
    descriptionAr: 'الموقع الرسمي للاتحاد العراقي لكرة القدم',
    descriptionEn: 'Official website of Iraq Football Association',
    descriptionKu: 'ماڵپەڕی فەرمیی یەکێتی تۆپی پێی عێراق',
    category: 'رياضة',
    active: true,
  },
];

// Portfolio Items
export const portfolioItems: PortfolioItem[] = [
  {
    id: 'portfolio-1',
    clientName: 'وزارة التربية',
    year: 2023,
    url: 'https://example.com',
    description: {
      ar: 'تطوير منصة إلكترونية متكاملة لإدارة المدارس',
      en: 'Development of integrated school management platform',
      ku: 'گەشەپێدانی پلاتفۆرمێکی ئەلیکترۆنی تەواو بۆ بەڕێوەبردنی قوتابخانەکان',
    },
    image: 'https://picsum.photos/seed/portfolio1/800/600',
    category: 'حكومي',
  },
  {
    id: 'portfolio-2',
    clientName: 'وزارة الصحة',
    year: 2022,
    description: {
      ar: 'نظام إدارة المستشفيات الإلكتروني',
      en: 'Electronic hospital management system',
      ku: 'سیستەمی بەڕێوەبردنی نەخۆشخانەی ئەلیکترۆنی',
    },
    image: 'https://picsum.photos/seed/portfolio2/800/600',
    category: 'حكومي',
  },
];

// Delegations
export const delegations: Delegation[] = [
  {
    id: 'deleg-1',
    officialName: 'د. علي حسن الربيعي',
    position: 'مدير عام دائرة تطوير الرياضة',
    destination: 'دبي',
    country: 'الإمارات',
    startDate: '2024-11-01',
    endDate: '2024-11-05',
    purpose: {
      ar: 'حضور مؤتمر الرياضة العربية',
      en: 'Attending Arab Sports Conference',
      ku: 'ئامادەبوون لە کۆنفرانسی وەرزشی عەرەبی',
    },
    departmentId: 'dept-1',
  },
  {
    id: 'deleg-2',
    officialName: 'سارة أحمد الجبوري',
    position: 'مدير عام دائرة شؤون الشباب',
    destination: 'القاهرة',
    country: 'مصر',
    startDate: '2024-10-15',
    endDate: '2024-10-20',
    purpose: {
      ar: 'مشاركة في ورشة عمل حول برامج الشباب',
      en: 'Participating in youth programs workshop',
      ku: 'بەشداریکردن لە کارگەی بەرنامەکانی لاوان',
    },
    departmentId: 'dept-2',
  },
  {
    id: 'deleg-3',
    officialName: 'كريم عباس الموسوي',
    position: 'مدير عام دائرة الاستثمار والتمويل الذاتي',
    destination: 'الرياض',
    country: 'السعودية',
    startDate: '2024-12-01',
    endDate: '2024-12-07',
    purpose: {
      ar: 'زيارة لدراسة مشاريع الاستثمار الرياضي',
      en: 'Visit to study sports investment projects',
      ku: 'سەردان بۆ لێکۆڵینەوە لە پرۆژەکانی وەبەرهێنانی وەرزشی',
    },
    departmentId: 'dept-3',
  },
  {
    id: 'deleg-4',
    officialName: 'محمد خالد النجار',
    position: 'مدير عام دائرة الإعلام والاتصال',
    destination: 'الدوحة',
    country: 'قطر',
    startDate: '2024-09-10',
    endDate: '2024-09-14',
    purpose: {
      ar: 'تغطية إعلامية لكأس الخليج',
      en: 'Media coverage of Gulf Cup',
      ku: 'دەرهێنانی میدیایی بۆ جامی کەنداوی',
    },
    departmentId: 'dept-4',
  },
  {
    id: 'deleg-5',
    officialName: 'فاطمة علي الكاظمي',
    position: 'مدير عام دائرة الرعاية العلمية',
    destination: 'عمان',
    country: 'الأردن',
    startDate: '2024-11-20',
    endDate: '2024-11-25',
    purpose: {
      ar: 'تبادل خبرات في برامج الرعاية العلمية',
      en: 'Exchanging expertise in scientific care programs',
      ku: 'گۆڕانکاری ئەزموون لە بەرنامەکانی چاودێری زانستی',
    },
    departmentId: 'dept-5',
  },
  {
    id: 'deleg-6',
    officialName: 'حسين عبدالله الشمري',
    position: 'مدير عام دائرة تطوير الرياضة',
    destination: 'الكويت',
    country: 'الكويت',
    startDate: '2024-10-05',
    endDate: '2024-10-10',
    purpose: {
      ar: 'مشاركة في بطولة الخليج للشباب',
      en: 'Participating in Gulf Youth Championship',
      ku: 'بەشداریکردن لە پاڵاوتنی کەنداوی بۆ لاوان',
    },
    departmentId: 'dept-1',
  },
  {
    id: 'deleg-7',
    officialName: 'ليلى محمود العبيدي',
    position: 'مدير عام دائرة شؤون الشباب',
    destination: 'بيروت',
    country: 'لبنان',
    startDate: '2024-12-10',
    endDate: '2024-12-15',
    purpose: {
      ar: 'حضور مؤتمر الشباب العربي',
      en: 'Attending Arab Youth Conference',
      ku: 'ئامادەبوون لە کۆنفرانسی لاوانی عەرەبی',
    },
    departmentId: 'dept-2',
  },
  {
    id: 'deleg-8',
    officialName: 'أحمد رضا الحسني',
    position: 'مدير عام دائرة الاستثمار والتمويل الذاتي',
    destination: 'مسقط',
    country: 'عمان',
    startDate: '2024-09-25',
    endDate: '2024-09-30',
    purpose: {
      ar: 'تفاوض حول اتفاقيات استثمارية',
      en: 'Negotiating investment agreements',
      ku: 'گفتوگۆکردن لەسەر ڕێکەوتننامەکانی وەبەرهێنان',
    },
    departmentId: 'dept-3',
  },
  {
    id: 'deleg-9',
    officialName: 'نورا سعد الدليمي',
    position: 'مدير عام دائرة الإعلام والاتصال',
    destination: 'المنامة',
    country: 'البحرين',
    startDate: '2024-11-10',
    endDate: '2024-11-14',
    purpose: {
      ar: 'ورشة عمل حول الإعلام الرياضي',
      en: 'Workshop on sports media',
      ku: 'کارگەی کار لەسەر میدیای وەرزشی',
    },
    departmentId: 'dept-4',
  },
  {
    id: 'deleg-10',
    officialName: 'عمر يوسف الطائي',
    position: 'مدير عام دائرة الرعاية العلمية',
    destination: 'تونس',
    country: 'تونس',
    startDate: '2024-10-20',
    endDate: '2024-10-26',
    purpose: {
      ar: 'زيارة لمراكز الرعاية العلمية',
      en: 'Visit to scientific care centers',
      ku: 'سەردان بۆ ناوەندەکانی چاودێری زانستی',
    },
    departmentId: 'dept-5',
  },
  {
    id: 'deleg-11',
    officialName: 'زينب كريم العلي',
    position: 'مدير عام دائرة تطوير الرياضة',
    destination: 'الدار البيضاء',
    country: 'المغرب',
    startDate: '2024-12-05',
    endDate: '2024-12-12',
    purpose: {
      ar: 'مشاركة في مؤتمر تطوير الرياضة العربية',
      en: 'Participating in Arab Sports Development Conference',
      ku: 'بەشداریکردن لە کۆنفرانسی گەشەپێدانی وەرزشی عەرەبی',
    },
    departmentId: 'dept-1',
  },
  {
    id: 'deleg-12',
    officialName: 'طارق فاضل الزبيدي',
    position: 'مدير عام دائرة شؤون الشباب',
    destination: 'الجزائر',
    country: 'الجزائر',
    startDate: '2024-09-15',
    endDate: '2024-09-22',
    purpose: {
      ar: 'تبادل خبرات في برامج الشباب',
      en: 'Exchanging expertise in youth programs',
      ku: 'گۆڕانکاری ئەزموون لە بەرنامەکانی لاوان',
    },
    departmentId: 'dept-2',
  },
  {
    id: 'deleg-13',
    officialName: 'رنا محسن الحيدري',
    position: 'مدير عام دائرة الاستثمار والتمويل الذاتي',
    destination: 'الرباط',
    country: 'المغرب',
    startDate: '2024-11-15',
    endDate: '2024-11-20',
    purpose: {
      ar: 'دراسة مشاريع تمويلية',
      en: 'Studying financing projects',
      ku: 'لێکۆڵینەوە لە پرۆژەکانی دارایی',
    },
    departmentId: 'dept-3',
  },
  {
    id: 'deleg-14',
    officialName: 'مصطفى جاسم العبيدي',
    position: 'مدير عام دائرة الإعلام والاتصال',
    destination: 'الخرطوم',
    country: 'السودان',
    startDate: '2024-10-01',
    endDate: '2024-10-07',
    purpose: {
      ar: 'تدريب على الإعلام الرياضي',
      en: 'Training on sports media',
      ku: 'ڕاهێنان لەسەر میدیای وەرزشی',
    },
    departmentId: 'dept-4',
  },
  {
    id: 'deleg-15',
    officialName: 'هند علي المالكي',
    position: 'مدير عام دائرة الرعاية العلمية',
    destination: 'دمشق',
    country: 'سوريا',
    startDate: '2024-12-15',
    endDate: '2024-12-20',
    purpose: {
      ar: 'زيارة لمراكز الرعاية العلمية',
      en: 'Visit to scientific care centers',
      ku: 'سەردان بۆ ناوەندەکانی چاودێری زانستی',
    },
    departmentId: 'dept-5',
  },
  {
    id: 'deleg-16',
    officialName: 'باسم خالد العاني',
    position: 'مدير عام دائرة تطوير الرياضة',
    destination: 'صنعاء',
    country: 'اليمن',
    startDate: '2024-09-05',
    endDate: '2024-09-10',
    purpose: {
      ar: 'مشاركة في بطولة عربية',
      en: 'Participating in Arab championship',
      ku: 'بەشداریکردن لە پاڵاوتنی عەرەبی',
    },
    departmentId: 'dept-1',
  },
  {
    id: 'deleg-17',
    officialName: 'سعدون محمود الجبوري',
    position: 'مدير عام دائرة شؤون الشباب',
    destination: 'طرابلس',
    country: 'ليبيا',
    startDate: '2024-11-25',
    endDate: '2024-11-30',
    purpose: {
      ar: 'مؤتمر الشباب العربي',
      en: 'Arab Youth Conference',
      ku: 'کۆنفرانسی لاوانی عەرەبی',
    },
    departmentId: 'dept-2',
  },
  {
    id: 'deleg-18',
    officialName: 'ميساء حسن الكعبي',
    position: 'مدير عام دائرة الاستثمار والتمويل الذاتي',
    destination: 'المنامة',
    country: 'البحرين',
    startDate: '2024-10-12',
    endDate: '2024-10-17',
    purpose: {
      ar: 'تفاوض حول اتفاقيات استثمارية',
      en: 'Negotiating investment agreements',
      ku: 'گفتوگۆکردن لەسەر ڕێکەوتننامەکانی وەبەرهێنان',
    },
    departmentId: 'dept-3',
  },
  {
    id: 'deleg-19',
    officialName: 'علي محسن الحسني',
    position: 'مدير عام دائرة الإعلام والاتصال',
    destination: 'مسقط',
    country: 'عمان',
    startDate: '2024-12-20',
    endDate: '2024-12-25',
    purpose: {
      ar: 'ورشة عمل حول الإعلام الرياضي',
      en: 'Workshop on sports media',
      ku: 'کارگەی کار لەسەر میدیای وەرزشی',
    },
    departmentId: 'dept-4',
  },
  {
    id: 'deleg-20',
    officialName: 'فاطمة أحمد الربيعي',
    position: 'مدير عام دائرة الرعاية العلمية',
    destination: 'الدوحة',
    country: 'قطر',
    startDate: '2024-09-20',
    endDate: '2024-09-25',
    purpose: {
      ar: 'تبادل خبرات في برامج الرعاية العلمية',
      en: 'Exchanging expertise in scientific care programs',
      ku: 'گۆڕانکاری ئەزموون لە بەرنامەکانی چاودێری زانستی',
    },
    departmentId: 'dept-5',
  },
];

// Site Settings
export const siteSettings: SiteSettings = {
  languages: ['ar', 'en', 'ku'],
  defaultLanguage: 'ar',
  brand: {
    logo: '/logo.png',
    nameAr: 'وزارة الشباب والرياضة',
    nameEn: 'Ministry of Youth and Sports',
    nameKu: 'وەزارەتی لاوان و وەرزش',
    taglineAr: 'بناء جيل واعٍ وقوي',
    taglineEn: 'Building a conscious and strong generation',
    taglineKu: 'بنیاتنانی نەوەیەکی ئاگادار و بەهێز',
  },
  contact: {
    email: 'info@moys.gov.iq',
    phone: '+964 1 7765432',
    address: {
      ar: 'بغداد، المنطقة الخضراء، شارع الأميرات',
      en: 'Baghdad, Green Zone, Al-Amirat Street',
      ku: 'بەغدا، ناوچەی سەوز، شەقامی ئەمیرات',
    },
    workingHours: {
      ar: 'الأحد - الخميس، 8:00 صباحاً - 3:00 مساءً',
      en: 'Sunday - Thursday, 8:00 AM - 3:00 PM',
      ku: 'یەکشەممە - پێنجشەممە، ٨:٠٠ بەیانی - ٣:٠٠ دوای نیوەڕۆ',
    },
  },
  social: {
    facebook: 'https://facebook.com/moys.iraq',
    twitter: 'https://twitter.com/moys_iraq',
    instagram: 'https://instagram.com/moys_iraq',
    youtube: 'https://youtube.com/@moysiraq',
  },
  supportPolicy: {
    ar: 'نوفر دعماً فنياً مجانياً لمدة سنة واحدة',
    en: 'We provide free technical support for one year',
    ku: 'پشتگیری تەکنیکی بەخۆڕایی دابین دەکەین بۆ ماوەی یەک ساڵ',
  },
  maintenanceMode: false,
};

// Mock Database
export const mockDB = {
  users,
  departments,
  posts,
  tenders,
  facilities,
  events,
  formSchemas,
  formSubmissions: [] as any[],
  talents,
  subsites,
  complaints: [] as Complaint[],
  securityClearances: [] as SecurityClearance[],
  portfolioItems,
  delegations,
  siteSettings,
};

